



























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { RequestService } from "@/services";
import Header from "@/components/Header.vue";
import {propertyTypes} from "@/services/properties";
import properties from "@/services/properties/global/danni-non-auto";
import data, { selectChoices } from "@/services/data/global/danni-non-auto";
import categories from "@/services/categories";
import { PnetDatePicker } from "@previnet/vue-datepicker";
import { it } from "vuejs-datepicker/dist/locale";
import { isNil } from "ramda";
import { format } from "date-fns";
import TextField from "@/components/TextField.vue";
import TextArea from "@/components/TextArea.vue";
import ComboBox from "@/components/ComboBox.vue";
import DatePicker from "@/components/DatePicker.vue";
import MultiComboBox from "@/components/MultiComboBox.vue";
import Frazionamento from "@/components/Frazionamento.vue";
import StringList from "@/components/StringList.vue";
import TextFieldSign from "@/components/TextFieldSign.vue";

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['productId', 'user', 'customCategory', 'customLabel'],
  components: {
    Header,
    TextField,
    ComboBox,
    DatePicker,
    MultiComboBox,
    Frazionamento,
    StringList,
    TextFieldSign,
    TextArea,
  },
  data: function() {
    return {
      loggedUser: this.$props.user,
      errorMsg: null as any,
      okMsg: null as any,
      modalErrorMsg: null as any,
      modalErrorTitle: null as any,
      ...properties,
      ...data,
      selectChoices,
      propertyTypes,
      it,
      ND: "n.d.",
      productIdSelected: this.$props.productId,
      propList: [],
      esitoRegistrazione: null as any,
      categories,
      altroTipologiaGaranzieAzienda: null,
      altroAssistenzaBiciclettaTipologia: null,
      altroAssistenzaInViaggioTipologia: null,
      altroAssistenzaAllaPersonaTipologia: null,
      altroTutelaLegalePersonaTipologia: null,
      altroIncendioAltriRischiCasaEFamigliaTipologia: null,
      altroAssistenzaCasaEFamigliaTipologia: null,
      altroTutelaLegaleCasaEFamigliaTipologia: null,
      altroRischiTecnologiciCasaEFamigliaTipologia: null,
      altroAnimaliDomesticiCasaEFamigliaTipologia: null,
      altroIncendioAltriRischiAziendaTipologia: null,
      altroRCAltriRischiAziendaTipologia: null,
      altroAssistenzaAziendaTipologia: null,
      altroTutelaLegaleAziendaTipologia: null,
      altroRischiTecnologiciAziendaTipologia: null,
      altroRCProfAreaTecnicaAltriRischiTipologia: null,
      altroRCProfAreaEconomicaGiuridicaAltriRischiTipologia: null,
      altroRCProfAreaMedicaAltriRischiTipologia: null,
      massiveFile: undefined,
      massiveLoaded: false,
      massiveResult: null as any,
    };
  },
  methods: {
    isNil,
    isEmptyOrSpaces(str: string) {
      return str === null || str.match(/^ *$/) !== null;
    },
    formatDate: function(data: Date | string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, "dd/MM/yyyy");
    },
    formatDateF: function(data: Date | string, formatStr: string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, formatStr);
    },
    dateFromString: function(value: string | Date) {
      if (typeof value !== "string" || isNil(value)) {
        return null;
      }

      const parts = value.split("/");
      if (parts.length == 3) {
        const dt = parts[1] + "/" + parts[0] + "/" + parts[2];

        const timestamp = Date.parse(dt);
        if (isNaN(timestamp) == false) {
          return new Date(timestamp);
        }
      }

      return null;
    },
    home: function() {
      const vm = this as any;
      vm.$router.push({ name: 'home-prodotti', params: {user: vm.loggedUser}});
    },
    openModalConfirm: function() {
      const vm = this as any;
      if (vm.checkFields() == true) {
        vm.valorizzaTendine();
        vm.preparePropList();

        if (vm.errorMsg == null && vm.propList.length > 0) {
          vm.$bvModal.show("modal-confirm");
        }
      }
    },
    closeModalConfirm() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm");
    },
    openModalMassivo: function() {
      const vm = this as any;
      vm.massiveFile = undefined;
      vm.massiveLoaded = false;
      vm.massiveResult = null;
      vm.$bvModal.show("modal-massive");
    },
    closeModalMassivo() {
      const vm = this as any;
      vm.$bvModal.hide("modal-massive");
    },
    openModalError(msg: any, title: any) {
      const vm = this as any;
      if (msg === undefined) {
        vm.modalErrorMsg = "Non è stato possibile salvare i dati.";
      } else {
        vm.modalErrorMsg = msg;
      }
      if (title === undefined) {
        vm.modalErrorTitle = "ERRORE";
      } else {
        vm.modalErrorTitle = title;
      }
      vm.$bvModal.show("modal-error");
    },
    closeModalError() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error");
    },
    openModalConfirmOutcome() {
      const vm = this as any;
      vm.$bvModal.show("modal-confirm-outcome");
    },
    closeModalConfirmOutcome() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm-outcome");
    },
    onClickReturnConfirmOutcome() {
      const vm = this as any;
      vm.closeModalConfirmOutcome();
    },
    onClickReturnError() {
      const vm = this as any;
      vm.closeModalError();
    },
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
    multivaluesContain(multivalues: any, values: any) {
      if (multivalues != null && values != null) {
        return multivalues.filter(function(e: any) {
          return values.indexOf(e.code) >= 0;
        }).length > 0;
      }

      return false;
    },
    checkFields() {
      const vm = this as any;

      let numErr = 0;

      vm.errorMsg = null;
      vm.okMsg = null;
      if (
        properties.prodottoProperty.value == undefined ||
        properties.prodottoProperty.value == null ||
        properties.prodottoProperty.value == ""
      ) {
        vm.errorMsg =
          "Il campo " + properties.prodottoProperty.name + " deve essere valorizzato";
        numErr++;
      }

      if (
        properties.codProdottoProperty.value == undefined ||
        properties.codProdottoProperty.value == null ||
        properties.codProdottoProperty.value == ""
      ) {
        vm.errorMsg =
          "Il campo " + properties.codProdottoProperty.name + " deve essere valorizzato";
        numErr++;
      }

      let retValue = true;
      if (numErr > 0) {
        retValue = false;
      } else {
        vm.okMsg = "Prodotto " + properties.prodottoProperty.value + " registrato";
      }

      return retValue;
    },
    changePiuTariffe() {
      const vm = this as any;

      if (selectChoices.piuTariffe.code == '1.2b') {
        properties.codProdCollegatoProperty.value = vm.ND;
      } else {
        properties.codProdCollegatoProperty.value = "";
      }
    },
    changeFineComm() {
      const vm = this as any;
      
      properties.fineCommProperty.value = "";
      properties.fineCommProperty.dateValue = null;

      if (selectChoices.prodCommercio.code == "16.1") {
        properties.fineCommProperty.value = vm.ND;
      }
    },
    changePremioTipologia() {
      const vm = this as any;
      properties.frazPremioProperty.value = "";
      properties.interessiFrazProperty.value = "";

      if (!vm.multivaluesContain(selectChoices.premioTipologia, ["24.1"])) {
        selectChoices.frazPremio = [];
        properties.frazPremioProperty.value = vm.ND;
        properties.frazPremioProperty.values = [];

        properties.interessiFrazProperty.value = vm.ND;
        properties.interessiFrazProperty.frazionamento = {
          mensile: "", mensileSign: "%",
          bimestrale: "", bimestraleSign: "%",
          trimestrale: "", trimestraleSign: "%",
          quadrimestrale: "", quadrimestraleSign: "%",
          semestrale: "", semestraleSign: "%",
        };
      }
    },
    countFrazionamento(prop: any) {
      const vm = this as any;
      let count = 0;

      if (prop !== undefined && prop.frazionamento !== undefined) {
        const f = prop.frazionamento;
        if (f.mensile !== vm.ND) count++;
        if (f.bimestrale !== vm.ND) count++;
        if (f.trimestrale !== vm.ND) count++;
        if (f.quadrimestrale !== vm.ND) count++;
        if (f.semestrale !== vm.ND) count++;
      }

      return count;
    },
    isInteressiFrazionamentoND() {
      const vm = this as any;
      const isPremioAnnuo = vm.multivaluesContain(selectChoices.premioTipologia, ["24.1"]);
      const isNoFraz = vm.multivaluesContain(selectChoices.frazPremio, ["26.6"]);

      return !isPremioAnnuo || isNoFraz;
    },
    isFrazionamentoMensile() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["26.1"]);
    },
    isFrazionamentoBimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["26.2"]);
    },
    isFrazionamentoTrimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["26.3"]);
    },
    isFrazionamentoQuadrimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["26.4"]);
    },
    isFrazionamentoSemestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["26.5"]);
    },
    changeFrazPremio() {
      const vm = this as any;
      properties.interessiFrazProperty.value = "";

      if (selectChoices.frazPremio.length == 0 || vm.multivaluesContain(selectChoices.frazPremio, ["26.6"])) {
        properties.interessiFrazProperty.value = vm.ND;
        properties.interessiFrazProperty.frazionamento = {
          mensile: "", mensileSign: "%",
          bimestrale: "", bimestraleSign: "%",
          trimestrale: "", trimestraleSign: "%",
          quadrimestrale: "", quadrimestraleSign: "%",
          semestrale: "", semestraleSign: "%",
        };
      }
    },
    changeTipologiaGaranzie() {
      const vm = this as any;
      //const flagTendinaTrue = true;

      // Mobilità
      if (!vm.multivaluesContain(selectChoices.lineaBusiness, ["10.1"])) {
        selectChoices.tipologiaGaranzieMobilita = [];
        properties.tipologiaGaranzieMobilitaProperty.value = vm.ND;
        properties.tipologiaGaranzieMobilitaProperty.values = [];

        selectChoices.rischiAssicuratiMobilita = [];
        properties.rischiAssicuratiMobilitaProperty.value = vm.ND;
        properties.rischiAssicuratiMobilitaProperty.values = [];

        properties.infortuniSuMezziSharingProperty.value = vm.ND;
        properties.infortuniInBiciclettaProperty.value = vm.ND;
        properties.responsabilitaCivileInBiciclettaProperty.value = vm.ND;
        properties.responsabilitaCivileMonopattinoProperty.value = vm.ND;
        properties.tutelaLegaleInBiciclettaProperty.value = vm.ND;
        properties.furtoBiciclettaProperty.value = vm.ND;

        selectChoices.assistenzaBiciclettaMobilitaTipologia = [];
        properties.assistenzaBiciclettaTipologiaProperty.value = vm.ND;
        properties.assistenzaBiciclettaTipologiaProperty.values = [];
        properties.assistenzaBiciclettaPeculiaritaProperty.value = vm.ND;

        properties.danniCausatiATerziInMobilitaProperty.value = vm.ND;
        properties.infortuniSuMezziPubbliciProperty.value = vm.ND;
        properties.infortuniInViaggioProperty.value = vm.ND;
        properties.rimborsoSpeseMedicheInViaggioProperty.value = vm.ND;
        properties.furtoInViaggioProperty.value = vm.ND;
        properties.furtoBagaglioProperty.value = vm.ND;
        properties.annullamentoViaggioProperty.value = vm.ND;

        selectChoices.assistenzaInViaggioMobilitaTipologia = [];
        properties.assistenzaInViaggioTipologiaProperty.value = vm.ND;
        properties.assistenzaInViaggioTipologiaProperty.values = [];
        properties.assistenzaInViaggioPeculiaritaProperty.value = vm.ND;

        properties.altreGaranzieMobilitaProperty.value = vm.ND;
      } else {
        properties.tipologiaGaranzieMobilitaProperty.value = "";
        properties.rischiAssicuratiMobilitaProperty.value = "";
        vm.setPropertyCondizionata(properties.infortuniSuMezziSharingProperty,selectChoices.rischiAssicuratiMobilita,["29.1"]);
        vm.setPropertyCondizionata(properties.infortuniInBiciclettaProperty,selectChoices.rischiAssicuratiMobilita,["29.2"]);
        vm.setPropertyCondizionata(properties.responsabilitaCivileInBiciclettaProperty,selectChoices.rischiAssicuratiMobilita,["29.3a"]);
        vm.setPropertyCondizionata(properties.responsabilitaCivileMonopattinoProperty,selectChoices.rischiAssicuratiMobilita,["29.3b"]);
        vm.setPropertyCondizionata(properties.tutelaLegaleInBiciclettaProperty,selectChoices.rischiAssicuratiMobilita,["29.4"]);
        vm.setPropertyCondizionata(properties.furtoBiciclettaProperty,selectChoices.rischiAssicuratiMobilita,["29.5"]);
        vm.setPropertyCondizionata(properties.assistenzaBiciclettaTipologiaProperty,selectChoices.rischiAssicuratiMobilita,["29.6"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiMobilita,["29.6"])) {
          selectChoices.assistenzaBiciclettaMobilitaTipologia = [];
        }
        vm.setPropertyCondizionata(properties.assistenzaBiciclettaPeculiaritaProperty,selectChoices.rischiAssicuratiMobilita,["29.6"]);
        vm.setPropertyCondizionata(properties.danniCausatiATerziInMobilitaProperty,selectChoices.rischiAssicuratiMobilita,["29.7"]);
        vm.setPropertyCondizionata(properties.infortuniSuMezziPubbliciProperty,selectChoices.rischiAssicuratiMobilita,["29.8"]);
        vm.setPropertyCondizionata(properties.infortuniInViaggioProperty,selectChoices.rischiAssicuratiMobilita,["29.9"]);
        vm.setPropertyCondizionata(properties.rimborsoSpeseMedicheInViaggioProperty,selectChoices.rischiAssicuratiMobilita,["29.10"]);
        vm.setPropertyCondizionata(properties.furtoInViaggioProperty,selectChoices.rischiAssicuratiMobilita,["29.11"]);
        vm.setPropertyCondizionata(properties.furtoBagaglioProperty,selectChoices.rischiAssicuratiMobilita,["29.12"]);
        vm.setPropertyCondizionata(properties.annullamentoViaggioProperty,selectChoices.rischiAssicuratiMobilita,["29.13"]);
        vm.setPropertyCondizionata(properties.assistenzaInViaggioTipologiaProperty,selectChoices.rischiAssicuratiMobilita,["29.14"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiMobilita,["29.14"])) {
          selectChoices.assistenzaInViaggioMobilitaTipologia = [];
        }
        vm.setPropertyCondizionata(properties.assistenzaInViaggioPeculiaritaProperty,selectChoices.rischiAssicuratiMobilita,["29.14"]);
        vm.setPropertyCondizionata(properties.altreGaranzieMobilitaProperty,selectChoices.rischiAssicuratiMobilita,["29.15"]);
      }

      // Persona
      if (!vm.multivaluesContain(selectChoices.lineaBusiness, ["10.2"])) {
        selectChoices.tipologiaGaranziePersona = [];
        properties.tipologiaGaranziePersonaProperty.value = vm.ND;
        properties.tipologiaGaranziePersonaProperty.values = [];

        selectChoices.rischiAssicuratiPersona = [];
        properties.rischiAssicuratiPersonaProperty.value = vm.ND;
        properties.rischiAssicuratiPersonaProperty.values = [];

        properties.morteDaInfortunioProperty.value = vm.ND;
        properties.invaliditaPermanenteDaInfortunioProperty.value = vm.ND;
        properties.inabilitaTemporaneaDaInfortunioProperty.value = vm.ND;
        properties.infortunioConIndennizzoForfettarioProperty.value = vm.ND;
        properties.morteDaMalattiaProperty.value = vm.ND;
        properties.invaliditaPermanenteDaMalattiaProperty.value = vm.ND;
        properties.inabilitaTemporaneaDaMalattiaProperty.value = vm.ND;
        properties.graviPatologieMalattieGraviProperty.value = vm.ND;
        properties.cureOncologicheProperty.value = vm.ND;
        properties.diariaDaRicoveroDaInfortunioMalattiaProperty.value = vm.ND;
        properties.diariaDaConvalescenzaProperty.value = vm.ND;
        properties.diariaDaImmobilizzazioneProperty.value = vm.ND;
        properties.rimborsoSpeseMedicheGenericheProperty.value = vm.ND;
        properties.rimborsoSpeseMedichePerGrandeInterventoChirurgicoProperty.value = vm.ND;
        properties.rimborsoSpeseMedichePerRicoveroOInterventoChirurgicoInGenereProperty.value = vm.ND;
        properties.visiteSpecialisticheEAccertamentiDiagnosticiProperty.value = vm.ND;
        properties.prestazioniAltaSpecializzazioneProperty.value = vm.ND;
        properties.trattamentiFisioterapiciRieducativiProperty.value = vm.ND;        
        properties.interventoChirurgicoConIndennizzoForfettarioProperty.value = vm.ND;
        properties.graviRicoveriConIndennizzoForfettarioProperty.value = vm.ND;
        properties.statoDiNonAutosufficienzaProperty.value = vm.ND;
        properties.statoDiNonAutosufficienzaTemporaneaProperty.value = vm.ND;
        properties.cureDentarieProperty.value = vm.ND;

        selectChoices.assistenzaAllaPersonaTipologia = [];
        properties.assistenzaAllaPersonaTipologiaProperty.value = vm.ND;
        properties.assistenzaAllaPersonaTipologiaProperty.values = [];
        properties.assistenzaAllaPersonaPeculiaritaProperty.value = vm.ND;

        properties.esamiDiPrevenzioneCheckUpProperty.value = vm.ND;
        properties.danniEsteticiProperty.value = vm.ND;
        properties.lentiCorrettiveDaVistaProperty.value = vm.ND;

        selectChoices.tutelaLegalePersonaTipologia = [];
        properties.tutelaLegalePersonaTipologiaProperty.value = vm.ND;
        properties.tutelaLegalePersonaTipologiaProperty.values = [];
        properties.tutelaLegalePersonaPeculiaritaProperty.value = vm.ND;

        properties.altreGaranziePersonaProperty.value = vm.ND;

        properties.limitiDiEtaProperty.value = vm.ND;
        properties.carenzeProperty.value = vm.ND;
      } else {
        properties.tipologiaGaranziePersonaProperty.value = "";
        properties.rischiAssicuratiPersonaProperty.value = "";
        vm.setPropertyCondizionata(properties.morteDaInfortunioProperty,selectChoices.rischiAssicuratiPersona,["44.1"]);
        vm.setPropertyCondizionata(properties.invaliditaPermanenteDaInfortunioProperty,selectChoices.rischiAssicuratiPersona,["44.2"]);
        vm.setPropertyCondizionata(properties.inabilitaTemporaneaDaInfortunioProperty,selectChoices.rischiAssicuratiPersona,["44.3"]);
        vm.setPropertyCondizionata(properties.infortunioConIndennizzoForfettarioProperty,selectChoices.rischiAssicuratiPersona,["44.4"]);
        vm.setPropertyCondizionata(properties.morteDaMalattiaProperty,selectChoices.rischiAssicuratiPersona,["44.5"]);
        vm.setPropertyCondizionata(properties.invaliditaPermanenteDaMalattiaProperty,selectChoices.rischiAssicuratiPersona,["44.6"]);
        vm.setPropertyCondizionata(properties.inabilitaTemporaneaDaMalattiaProperty,selectChoices.rischiAssicuratiPersona,["44.7"]);
        vm.setPropertyCondizionata(properties.graviPatologieMalattieGraviProperty,selectChoices.rischiAssicuratiPersona,["44.8a"]);
        vm.setPropertyCondizionata(properties.cureOncologicheProperty,selectChoices.rischiAssicuratiPersona,["44.8b"]);
        vm.setPropertyCondizionata(properties.diariaDaRicoveroDaInfortunioMalattiaProperty,selectChoices.rischiAssicuratiPersona,["44.9"]);
        vm.setPropertyCondizionata(properties.diariaDaConvalescenzaProperty,selectChoices.rischiAssicuratiPersona,["44.10a"]);
        vm.setPropertyCondizionata(properties.diariaDaImmobilizzazioneProperty,selectChoices.rischiAssicuratiPersona,["44.10b"]);
        vm.setPropertyCondizionata(properties.rimborsoSpeseMedicheGenericheProperty,selectChoices.rischiAssicuratiPersona,["44.11"]);
        vm.setPropertyCondizionata(properties.rimborsoSpeseMedichePerGrandeInterventoChirurgicoProperty,selectChoices.rischiAssicuratiPersona,["44.12"]);
        vm.setPropertyCondizionata(properties.rimborsoSpeseMedichePerRicoveroOInterventoChirurgicoInGenereProperty,selectChoices.rischiAssicuratiPersona,["44.13"]);
        vm.setPropertyCondizionata(properties.visiteSpecialisticheEAccertamentiDiagnosticiProperty,selectChoices.rischiAssicuratiPersona,["44.14a"]);
        vm.setPropertyCondizionata(properties.prestazioniAltaSpecializzazioneProperty,selectChoices.rischiAssicuratiPersona,["44.14b"]);
        vm.setPropertyCondizionata(properties.trattamentiFisioterapiciRieducativiProperty,selectChoices.rischiAssicuratiPersona,["44.14c"]);
        vm.setPropertyCondizionata(properties.interventoChirurgicoConIndennizzoForfettarioProperty,selectChoices.rischiAssicuratiPersona,["44.15"]);
        vm.setPropertyCondizionata(properties.graviRicoveriConIndennizzoForfettarioProperty,selectChoices.rischiAssicuratiPersona,["44.16"]);
        vm.setPropertyCondizionata(properties.statoDiNonAutosufficienzaProperty,selectChoices.rischiAssicuratiPersona,["44.17a"]);
        vm.setPropertyCondizionata(properties.statoDiNonAutosufficienzaTemporaneaProperty,selectChoices.rischiAssicuratiPersona,["44.17b"]);
        vm.setPropertyCondizionata(properties.cureDentarieProperty,selectChoices.rischiAssicuratiPersona,["44.18"]);
        vm.setPropertyCondizionata(properties.assistenzaAllaPersonaTipologiaProperty,selectChoices.rischiAssicuratiPersona,["44.19"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiPersona,["44.19"])) {
          selectChoices.assistenzaAllaPersonaTipologia = [];
        }
        vm.setPropertyCondizionata(properties.assistenzaAllaPersonaPeculiaritaProperty,selectChoices.rischiAssicuratiPersona,["44.19"]);
        vm.setPropertyCondizionata(properties.esamiDiPrevenzioneCheckUpProperty,selectChoices.rischiAssicuratiPersona,["44.20"]);
        vm.setPropertyCondizionata(properties.danniEsteticiProperty,selectChoices.rischiAssicuratiPersona,["44.21"]);
        vm.setPropertyCondizionata(properties.lentiCorrettiveDaVistaProperty,selectChoices.rischiAssicuratiPersona,["44.22"]);
        vm.setPropertyCondizionata(properties.tutelaLegalePersonaTipologiaProperty,selectChoices.rischiAssicuratiPersona,["44.23"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiPersona,["44.23"])) {
          selectChoices.tutelaLegalePersonaTipologia = [];
        }
        vm.setPropertyCondizionata(properties.tutelaLegalePersonaPeculiaritaProperty,selectChoices.rischiAssicuratiPersona,["44.23"]);
        vm.setPropertyCondizionata(properties.altreGaranziePersonaProperty,selectChoices.rischiAssicuratiPersona,["44.24"]);

        vm.setPropertyValueBlankIfND(properties.limitiDiEtaProperty);
        vm.setPropertyValueBlankIfND(properties.carenzeProperty);
      }

      // Casa e Famiglia
      if (!vm.multivaluesContain(selectChoices.lineaBusiness, ["10.3"])) {
        selectChoices.tipologiaGaranzieCasaEFamiglia = [];
        properties.tipologiaGaranzieCasaEFamigliaProperty.value = vm.ND;
        properties.tipologiaGaranzieCasaEFamigliaProperty.values = [];

        selectChoices.rischiAssicuratiCasaEFamiglia = [];
        properties.rischiAssicuratiCasaEFamigliaProperty.value = vm.ND;
        properties.rischiAssicuratiCasaEFamigliaProperty.values = [];

        properties.incendioMutuiCasaEFamigliaProperty.value = vm.ND;
        properties.incendioFabbricatoCasaEFamigliaProperty.value = vm.ND;
        properties.incendioContenutoCasaEFamigliaProperty.value = vm.ND;

        selectChoices.incendioAltriRischiCasaEFamigliaTipologia = [];
        properties.incendioAltriRischiCasaEFamigliaTipologiaProperty.value = vm.ND;
        properties.incendioAltriRischiCasaEFamigliaTipologiaProperty.values = [];
        properties.incendioAltriRischiCasaEFamigliaPeculiaritaProperty.value = vm.ND;

        properties.ricorsoTerziCasaEFamigliaProperty.value = vm.ND;
        properties.rischiCatastrofaliTerremotoCasaEFamigliaProperty.value = vm.ND;
        properties.rischiCatastrofaliAlluvioneInondazioneCasaEFamigliaProperty.value = vm.ND;
        properties.RCProprietaDelFabbricatoCasaEFamigliaProperty.value = vm.ND;
        properties.RCConduzioneProperty.value = vm.ND;
        properties.RCVitaPrivataProperty.value = vm.ND;
        properties.RCRCOCasaEFamigliaProperty.value = vm.ND;
        properties.RCAltriRischiCasaEFamigliaProperty.value = vm.ND;
        properties.cristalliProperty.value = vm.ND;
        properties.furtoERapinaCasaEFamigliaProperty.value = vm.ND;

        selectChoices.assistenzaCasaEFamigliaTipologia = [];
        properties.assistenzaCasaEFamigliaTipologiaProperty.value = vm.ND;
        properties.assistenzaCasaEFamigliaTipologiaProperty.values = [];
        properties.assistenzaCasaEFamigliaPeculiaritaProperty.value = vm.ND;

        selectChoices.tutelaLegaleCasaEFamigliaTipologia = [];
        properties.tutelaLegaleCasaEFamigliaTipologiaProperty.value = vm.ND;
        properties.tutelaLegaleCasaEFamigliaTipologiaProperty.values = [];
        properties.tutelaLegaleCasaEFamigliaPeculiaritaProperty.value = vm.ND;

        properties.elettronicaCasaEFamigliaProperty.value = vm.ND;

        selectChoices.rischiTecnologiciCasaEFamigliaTipologia = [];
        properties.rischiTecnologiciCasaEFamigliaTipologiaProperty.value = vm.ND;
        properties.rischiTecnologiciCasaEFamigliaTipologiaProperty.values = [];
        properties.rischiTecnologiciCasaEFamigliaPeculiaritaProperty.value = vm.ND;

        selectChoices.animaliDomesticiCasaEFamigliaTipologia = [];
        properties.animaliDomesticiCasaEFamigliaTipologiaProperty.value = vm.ND;
        properties.animaliDomesticiCasaEFamigliaTipologiaProperty.values = [];
        properties.animaliDomesticiCasaEFamigliaPeculiaritaProperty.value = vm.ND;

        properties.altreGaranzieCasaEFamigliaProperty.value = vm.ND;
      } else {
        properties.tipologiaGaranzieCasaEFamigliaProperty.value = "";
        properties.rischiAssicuratiCasaEFamigliaProperty.value = "";
        vm.setPropertyCondizionata(properties.incendioMutuiCasaEFamigliaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.1"]);
        vm.setPropertyCondizionata(properties.incendioFabbricatoCasaEFamigliaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.2"]);
        vm.setPropertyCondizionata(properties.incendioContenutoCasaEFamigliaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.3"]);
        vm.setPropertyCondizionata(properties.incendioAltriRischiCasaEFamigliaTipologiaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.4"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiCasaEFamiglia,["73.4"])) {
          selectChoices.incendioAltriRischiCasaEFamigliaTipologia = [];
        }
        vm.setPropertyCondizionata(properties.incendioAltriRischiCasaEFamigliaPeculiaritaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.4"]);
        vm.setPropertyCondizionata(properties.ricorsoTerziCasaEFamigliaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.5"]);
        vm.setPropertyCondizionata(properties.rischiCatastrofaliTerremotoCasaEFamigliaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.6"]);
        vm.setPropertyCondizionata(properties.rischiCatastrofaliAlluvioneInondazioneCasaEFamigliaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.7"]);
        vm.setPropertyCondizionata(properties.RCProprietaDelFabbricatoCasaEFamigliaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.8"]);
        vm.setPropertyCondizionata(properties.RCConduzioneProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.9"]);
        vm.setPropertyCondizionata(properties.RCVitaPrivataProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.10"]);
        vm.setPropertyCondizionata(properties.RCRCOCasaEFamigliaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.11"]);
        vm.setPropertyCondizionata(properties.RCAltriRischiCasaEFamigliaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.12"]);
        vm.setPropertyCondizionata(properties.cristalliProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.13"]);
        vm.setPropertyCondizionata(properties.furtoERapinaCasaEFamigliaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.14"]);
        vm.setPropertyCondizionata(properties.assistenzaCasaEFamigliaTipologiaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.15"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiCasaEFamiglia,["73.15"])) {
          selectChoices.assistenzaCasaEFamigliaTipologia = [];
        }
        vm.setPropertyCondizionata(properties.assistenzaCasaEFamigliaPeculiaritaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.15"]);
        vm.setPropertyCondizionata(properties.tutelaLegaleCasaEFamigliaTipologiaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.16"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiCasaEFamiglia,["73.16"])) {
          selectChoices.tutelaLegaleCasaEFamigliaTipologia = [];
        }
        vm.setPropertyCondizionata(properties.tutelaLegaleCasaEFamigliaPeculiaritaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.16"]);
        vm.setPropertyCondizionata(properties.elettronicaCasaEFamigliaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.17"]);
        vm.setPropertyCondizionata(properties.rischiTecnologiciCasaEFamigliaTipologiaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.18"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiCasaEFamiglia,["73.18"])) {
          selectChoices.rischiTecnologiciCasaEFamigliaTipologia = [];
        }
        vm.setPropertyCondizionata(properties.rischiTecnologiciCasaEFamigliaPeculiaritaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.18"]);
        vm.setPropertyCondizionata(properties.animaliDomesticiCasaEFamigliaTipologiaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.19"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiCasaEFamiglia,["73.19"])) {
          selectChoices.animaliDomesticiCasaEFamigliaTipologia = [];
        }
        vm.setPropertyCondizionata(properties.animaliDomesticiCasaEFamigliaPeculiaritaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.19"]);
        vm.setPropertyCondizionata(properties.altreGaranzieCasaEFamigliaProperty,selectChoices.rischiAssicuratiCasaEFamiglia,["73.20"]);
      }

      // Azienda
      if (!vm.multivaluesContain(selectChoices.lineaBusiness, ["10.4"])) {
        selectChoices.tipologiaGaranzieAzienda = [];
        properties.tipologiaGaranzieAziendaProperty.value = vm.ND;
        properties.tipologiaGaranzieAziendaProperty.values = [];

        selectChoices.rischiAssicuratiAzienda = [];
        properties.rischiAssicuratiAziendaProperty.value = vm.ND;
        properties.rischiAssicuratiAziendaProperty.values = [];

        properties.incendioMutuiAziendaProperty.value = vm.ND;
        properties.incendioFabbricatoAziendaProperty.value = vm.ND;
        properties.incendioContenutoAziendaProperty.value = vm.ND;

        selectChoices.incendioAltriRischiAziendaTipologia = [];
        properties.incendioAltriRischiAziendaTipologiaProperty.value = vm.ND;
        properties.incendioAltriRischiAziendaTipologiaProperty.values = [];
        properties.incendioAltriRischiPeculiaritaAziendaProperty.value = vm.ND;

        properties.ricorsoTerziAziendaProperty.value = vm.ND;
        properties.rischiCatastrofaliTerremotoAziendaProperty.value = vm.ND;
        properties.rischiCatastrofaliAlluvioneInondazioneAziendaProperty.value = vm.ND;
        properties.RCProprietaDelFabbricatoAziendaProperty.value = vm.ND;
        properties.RCRCTAziendaProperty.value = vm.ND;
        properties.RCRCOAziendaProperty.value = vm.ND;

        selectChoices.RCAltriRischiAziendaTipologia = [];
        properties.RCAltriRischiAziendaTipologiaProperty.value = vm.ND;
        properties.RCAltriRischiAziendaTipologiaProperty.values = [];
        properties.RCAltriRischiPeculiaritaAziendaProperty.value = vm.ND;

        properties.furtoERapinaAziendaProperty.value = vm.ND;

        selectChoices.assistenzaAziendaTipologia = [];
        properties.assistenzaAziendaTipologiaProperty.value = vm.ND;
        properties.assistenzaAziendaTipologiaProperty.values = [];
        properties.assistenzaAziendaPeculiaritaProperty.value = vm.ND;

        selectChoices.tutelaLegaleAziendaTipologia = [];
        properties.tutelaLegaleAziendaTipologiaProperty.value = vm.ND;
        properties.tutelaLegaleAziendaTipologiaProperty.values = [];
        properties.tutelaLegaleAziendaPeculiaritaProperty.value = vm.ND;

        properties.elettronicaAziendaProperty.value = vm.ND;
        properties.danniIndirettiAziendaProperty.value = vm.ND;
        properties.vetriEInsegneAziendaProperty.value = vm.ND;

        selectChoices.rischiTecnologiciAziendaTipologia = [];
        properties.rischiTecnologiciAziendaTipologiaProperty.value = vm.ND;
        properties.rischiTecnologiciAziendaTipologiaProperty.values = [];
        properties.rischiTecnologiciAziendaPeculiaritaProperty.value = vm.ND;

        properties.altreGaranzieAziendaProperty.value = vm.ND;
      } else {
        properties.tipologiaGaranzieAziendaProperty.value = "";
        properties.rischiAssicuratiAziendaProperty.value = "";
        vm.setPropertyCondizionata(properties.incendioMutuiAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.1"]);
        vm.setPropertyCondizionata(properties.incendioFabbricatoAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.2"]);
        vm.setPropertyCondizionata(properties.incendioContenutoAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.3"]);
        vm.setPropertyCondizionata(properties.incendioAltriRischiAziendaTipologiaProperty,selectChoices.rischiAssicuratiAzienda,["99.4"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiAzienda,["99.4"])) {
          selectChoices.incendioAltriRischiAziendaTipologia = [];
        }
        vm.setPropertyCondizionata(properties.incendioAltriRischiPeculiaritaAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.4"]);
        vm.setPropertyCondizionata(properties.ricorsoTerziAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.5"]);
        vm.setPropertyCondizionata(properties.rischiCatastrofaliTerremotoAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.6"]);
        vm.setPropertyCondizionata(properties.rischiCatastrofaliAlluvioneInondazioneAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.7"]);
        vm.setPropertyCondizionata(properties.RCProprietaDelFabbricatoAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.8"]);
        vm.setPropertyCondizionata(properties.RCRCTAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.9"]);
        vm.setPropertyCondizionata(properties.RCRCOAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.10"]);
        vm.setPropertyCondizionata(properties.RCAltriRischiAziendaTipologiaProperty,selectChoices.rischiAssicuratiAzienda,["99.11"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiAzienda,["99.11"])) {
          selectChoices.RCAltriRischiAziendaTipologia = [];
        }
        vm.setPropertyCondizionata(properties.RCAltriRischiPeculiaritaAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.11"]);
        vm.setPropertyCondizionata(properties.furtoERapinaAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.12"]);
        vm.setPropertyCondizionata(properties.assistenzaAziendaTipologiaProperty,selectChoices.rischiAssicuratiAzienda,["99.13"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiAzienda,["99.13"])) {
          selectChoices.assistenzaAziendaTipologia = [];
        }
        vm.setPropertyCondizionata(properties.assistenzaAziendaPeculiaritaProperty,selectChoices.rischiAssicuratiAzienda,["99.13"]);
        vm.setPropertyCondizionata(properties.tutelaLegaleAziendaTipologiaProperty,selectChoices.rischiAssicuratiAzienda,["99.14"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiAzienda,["99.14"])) {
          selectChoices.tutelaLegaleAziendaTipologia = [];
        }
        vm.setPropertyCondizionata(properties.tutelaLegaleAziendaPeculiaritaProperty,selectChoices.rischiAssicuratiAzienda,["99.14"]);
        vm.setPropertyCondizionata(properties.elettronicaAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.15"]);
        vm.setPropertyCondizionata(properties.danniIndirettiAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.16"]);
        vm.setPropertyCondizionata(properties.vetriEInsegneAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.17"]);
        properties.rischiTecnologiciAziendaTipologiaProperty.value = "";
        vm.setPropertyCondizionata(properties.rischiTecnologiciAziendaTipologiaProperty,selectChoices.rischiAssicuratiAzienda,["99.18"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiAzienda,["99.18"])) {
          selectChoices.rischiTecnologiciAziendaTipologia = [];
        }
        vm.setPropertyCondizionata(properties.rischiTecnologiciAziendaPeculiaritaProperty,selectChoices.rischiAssicuratiAzienda,["99.18"]);
        vm.setPropertyCondizionata(properties.altreGaranzieAziendaProperty,selectChoices.rischiAssicuratiAzienda,["99.19"]);
      }

      // Professionisti
      if (!vm.multivaluesContain(selectChoices.lineaBusiness, ["10.5"])) {
        selectChoices.tipologiaGaranzieProfessionisti = [];
        properties.tipologiaGaranzieProfessionistiProperty.value = vm.ND;
        properties.tipologiaGaranzieProfessionistiProperty.values = [];

        selectChoices.rischiAssicuratiProfessionisti = [];
        properties.rischiAssicuratiProfessionistiProperty.value = vm.ND;
        properties.rischiAssicuratiProfessionistiProperty.values = [];

        properties.RCProfAreaTecnicaProperty.value = vm.ND;

        selectChoices.RCProfAreaTecnicaAltriRischiTipologia = [];
        properties.RCProfAreaTecnicaAltriRischiTipologiaProperty.value = vm.ND;
        properties.RCProfAreaTecnicaAltriRischiTipologiaProperty.values = [];
        properties.RCProfAreaTecnicaAltriRischiPeculiaritaProperty.value = vm.ND;

        properties.RCProfAreaEconomicaGiuridicaProperty.value = vm.ND;

        selectChoices.RCProfAreaEconomicaGiuridicaAltriRischiTipologia = [];
        properties.RCProfAreaEconomicaGiuridicaAltriRischiTipologiaProperty.value = vm.ND;
        properties.RCProfAreaEconomicaGiuridicaAltriRischiTipologiaProperty.values = [];
        properties.RCProfAreaEconomicaGiuridicaAltriRischiPeculiaritaProperty.value = vm.ND;
        
        properties.RCProfAreaMedicaProperty.value = vm.ND;

        selectChoices.RCProfAreaMedicaAltriRischiTipologia = [];
        properties.RCProfAreaMedicaAltriRischiTipologiaProperty.value = vm.ND;
        properties.RCProfAreaMedicaAltriRischiTipologiaProperty.values = [];
        properties.RCProfAreaMedicaAltriRischiPeculiaritaProperty.value = vm.ND;
        
        properties.RCProfAltraAreaProperty.value = vm.ND;
        properties.RCRCTProfessionistiProperty.value = vm.ND;
        properties.RCRCOProfessionistiProperty.value = vm.ND;
        properties.RCProprietaEConduzioneProperty.value = vm.ND;
        properties.assistenzaProfessionistiProperty.value = vm.ND;
        properties.tutelaLegaleProfessionistiProperty.value = vm.ND;
        properties.rischiTecnologiciProfessionistiProperty.value = vm.ND;
        properties.infortuniProperty.value = vm.ND;
        properties.incendioEDanniAllaProprietaProperty.value = vm.ND;
        properties.furtoERapinaProfessionistiProperty.value = vm.ND;
        properties.elettronicaProfessionistiProperty.value = vm.ND;
        properties.vetriECristalliProfessionistiProperty.value = vm.ND;
        properties.altreGaranzieProfessionistiProperty.value = vm.ND;
      } else {
        properties.tipologiaGaranzieProfessionistiProperty.value = "";
        properties.rischiAssicuratiProfessionistiProperty.value = "";
        vm.setPropertyCondizionata(properties.RCProfAreaTecnicaProperty,selectChoices.rischiAssicuratiProfessionisti,["124.1"]);
        vm.setPropertyCondizionata(properties.RCProfAreaTecnicaAltriRischiTipologiaProperty,selectChoices.rischiAssicuratiProfessionisti,["124.2"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiProfessionisti,["124.2"])) {
          selectChoices.RCProfAreaTecnicaAltriRischiTipologia = [];
        }
        vm.setPropertyCondizionata(properties.RCProfAreaTecnicaAltriRischiPeculiaritaProperty,selectChoices.rischiAssicuratiProfessionisti,["124.2"]);
        vm.setPropertyCondizionata(properties.RCProfAreaEconomicaGiuridicaProperty,selectChoices.rischiAssicuratiProfessionisti,["124.3"]);
        vm.setPropertyCondizionata(properties.RCProfAreaEconomicaGiuridicaAltriRischiTipologiaProperty,selectChoices.rischiAssicuratiProfessionisti,["124.4"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiProfessionisti,["124.4"])) {
          selectChoices.RCProfAreaEconomicaGiuridicaAltriRischiTipologia = [];
        }
        vm.setPropertyCondizionata(properties.RCProfAreaEconomicaGiuridicaAltriRischiPeculiaritaProperty,selectChoices.rischiAssicuratiProfessionisti,["124.4"]);
        vm.setPropertyCondizionata(properties.RCProfAreaMedicaProperty,selectChoices.rischiAssicuratiProfessionisti,["124.5"]);
        vm.setPropertyCondizionata(properties.RCProfAreaMedicaAltriRischiTipologiaProperty,selectChoices.rischiAssicuratiProfessionisti,["124.6"]);
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiProfessionisti,["124.6"])) {
          selectChoices.RCProfAreaMedicaAltriRischiTipologia = [];
        }
        vm.setPropertyCondizionata(properties.RCProfAreaMedicaAltriRischiPeculiaritaProperty,selectChoices.rischiAssicuratiProfessionisti,["124.6"]);
        vm.setPropertyCondizionata(properties.RCProfAltraAreaProperty,selectChoices.rischiAssicuratiProfessionisti,["124.7"]);
        vm.setPropertyCondizionata(properties.RCRCTProfessionistiProperty,selectChoices.rischiAssicuratiProfessionisti,["124.8"]);
        vm.setPropertyCondizionata(properties.RCRCOProfessionistiProperty,selectChoices.rischiAssicuratiProfessionisti,["124.9"]);
        vm.setPropertyCondizionata(properties.RCProprietaEConduzioneProperty,selectChoices.rischiAssicuratiProfessionisti,["124.10"]);
        vm.setPropertyCondizionata(properties.assistenzaProfessionistiProperty,selectChoices.rischiAssicuratiProfessionisti,["124.11"]);
        vm.setPropertyCondizionata(properties.tutelaLegaleProfessionistiProperty,selectChoices.rischiAssicuratiProfessionisti,["124.12"]);
        vm.setPropertyCondizionata(properties.rischiTecnologiciProfessionistiProperty,selectChoices.rischiAssicuratiProfessionisti,["124.13"]);
        vm.setPropertyCondizionata(properties.infortuniProperty,selectChoices.rischiAssicuratiProfessionisti,["124.14"]);
        vm.setPropertyCondizionata(properties.incendioEDanniAllaProprietaProperty,selectChoices.rischiAssicuratiProfessionisti,["124.15"]);
        vm.setPropertyCondizionata(properties.furtoERapinaProfessionistiProperty,selectChoices.rischiAssicuratiProfessionisti,["124.16"]);
        vm.setPropertyCondizionata(properties.elettronicaProfessionistiProperty,selectChoices.rischiAssicuratiProfessionisti,["124.17"]);
        vm.setPropertyCondizionata(properties.vetriECristalliProfessionistiProperty,selectChoices.rischiAssicuratiProfessionisti,["124.18"]);
        vm.setPropertyCondizionata(properties.altreGaranzieProfessionistiProperty,selectChoices.rischiAssicuratiProfessionisti,["124.19"]);
      }
    },
    valorizzaTendine() {
      properties.piuTariffeProperty.code = selectChoices.piuTariffe.code;
      properties.piuTariffeProperty.value = selectChoices.piuTariffe.description;
      properties.compagniaProperty.code = selectChoices.compagnia.code;
      properties.compagniaProperty.value = selectChoices.compagnia.description;
      properties.compagniaProperty.extCode = selectChoices.compagnia.extCode;
      properties.canaleProperty.values = selectChoices.canale;
      properties.distributoriProperty.values = selectChoices.distributori;
      properties.modDistribuzioneProperty.values = selectChoices.modDistribuzione;
      properties.mercatoProperty.values = selectChoices.mercato;
      properties.lineaBusinessProperty.values = selectChoices.lineaBusiness;
      properties.tipologiaGaranzieMobilitaProperty.values = selectChoices.tipologiaGaranzieMobilita;
      properties.tipologiaGaranziePersonaProperty.values = selectChoices.tipologiaGaranziePersona;
      properties.tipologiaGaranzieCasaEFamigliaProperty.values = selectChoices.tipologiaGaranzieCasaEFamiglia;
      properties.tipologiaGaranzieAziendaProperty.values = selectChoices.tipologiaGaranzieAzienda;
      properties.tipologiaGaranzieProfessionistiProperty.values = selectChoices.tipologiaGaranzieProfessionisti;
      properties.prodCommercioProperty.code = selectChoices.prodCommercio.code;
      properties.prodCommercioProperty.value = selectChoices.prodCommercio.description;
      properties.tipoAssicurazioneProperty.code = selectChoices.tipoAssicurazione.code;
      properties.tipoAssicurazioneProperty.value = selectChoices.tipoAssicurazione.description;
      properties.combGaranzieTipologiaProperty.code = selectChoices.combGaranzieTipologia.code;
      properties.combGaranzieTipologiaProperty.value = selectChoices.combGaranzieTipologia.description;
      properties.premioTipologiaProperty.values = selectChoices.premioTipologia;
      properties.frazPremioProperty.values = selectChoices.frazPremio;
      properties.rischiAssicuratiMobilitaProperty.values = selectChoices.rischiAssicuratiMobilita;
      properties.assistenzaBiciclettaTipologiaProperty.values = selectChoices.assistenzaBiciclettaMobilitaTipologia;
      properties.assistenzaInViaggioTipologiaProperty.values = selectChoices.assistenzaInViaggioMobilitaTipologia;
      properties.rischiAssicuratiPersonaProperty.values = selectChoices.rischiAssicuratiPersona;
      properties.assistenzaAllaPersonaTipologiaProperty.values = selectChoices.assistenzaAllaPersonaTipologia;
      properties.tutelaLegalePersonaTipologiaProperty.values = selectChoices.tutelaLegalePersonaTipologia;
      properties.rischiAssicuratiCasaEFamigliaProperty.values = selectChoices.rischiAssicuratiCasaEFamiglia;
      properties.incendioAltriRischiCasaEFamigliaTipologiaProperty.values = selectChoices.incendioAltriRischiCasaEFamigliaTipologia;
      properties.assistenzaCasaEFamigliaTipologiaProperty.values = selectChoices.assistenzaCasaEFamigliaTipologia;
      properties.tutelaLegaleCasaEFamigliaTipologiaProperty.values = selectChoices.tutelaLegaleCasaEFamigliaTipologia;
      properties.rischiTecnologiciCasaEFamigliaTipologiaProperty.values = selectChoices.rischiTecnologiciCasaEFamigliaTipologia;
      properties.animaliDomesticiCasaEFamigliaTipologiaProperty.values = selectChoices.animaliDomesticiCasaEFamigliaTipologia;
      properties.rischiAssicuratiAziendaProperty.values = selectChoices.rischiAssicuratiAzienda;
      properties.incendioAltriRischiAziendaTipologiaProperty.values = selectChoices.incendioAltriRischiAziendaTipologia;
      properties.RCAltriRischiAziendaTipologiaProperty.values = selectChoices.RCAltriRischiAziendaTipologia;
      properties.assistenzaAziendaTipologiaProperty.values = selectChoices.assistenzaAziendaTipologia;
      properties.tutelaLegaleAziendaTipologiaProperty.values = selectChoices.tutelaLegaleAziendaTipologia;
      properties.rischiTecnologiciAziendaTipologiaProperty.values = selectChoices.rischiTecnologiciAziendaTipologia;
      properties.rischiAssicuratiProfessionistiProperty.values = selectChoices.rischiAssicuratiProfessionisti;
      properties.RCProfAreaTecnicaAltriRischiTipologiaProperty.values = selectChoices.RCProfAreaTecnicaAltriRischiTipologia;
      properties.RCProfAreaEconomicaGiuridicaAltriRischiTipologiaProperty.values = selectChoices.RCProfAreaEconomicaGiuridicaAltriRischiTipologia;
      properties.RCProfAreaMedicaAltriRischiTipologiaProperty.values = selectChoices.RCProfAreaMedicaAltriRischiTipologia;
    },
    cleanAllProperties() {
      const vm = this as any;

      properties.prodottoProperty.value = "";
      properties.codProdottoProperty.value = "";
      properties.piuTariffeProperty.code = ""; properties.piuTariffeProperty.value = "";
      properties.codProdCollegatoProperty.value = "";
      properties.compagniaProperty.code = ""; properties.compagniaProperty.value = ""; properties.compagniaProperty.extCode = "";
      properties.canaleProperty.values = [];
      properties.distributoriProperty.values = [];
      properties.modDistribuzioneProperty.values = [];
      properties.mercatoProperty.values = [];
      properties.destinatariProperty.value = "";
      properties.targetMarketProperty.value = "";
      properties.descProdottoProperty.value = "";
      properties.lineaBusinessProperty.values = [];
      properties.tipologiaGaranzieMobilitaProperty.values = [];
      properties.tipologiaGaranziePersonaProperty.values = [];
      properties.tipologiaGaranzieCasaEFamigliaProperty.values = [];
      properties.tipologiaGaranzieAziendaProperty.values = [];
      properties.tipologiaGaranzieProfessionistiProperty.values = [];
      properties.prodCommercioProperty.code = ""; properties.prodCommercioProperty.value = "";
      properties.inizioCommProperty.value = ""; properties.inizioCommProperty.dateValue = null;
      properties.fineCommProperty.value = ""; properties.fineCommProperty.dateValue = null;
      properties.edizioneDIPAggProperty.value = ""; properties.edizioneDIPAggProperty.dateValue = null;
      properties.tipoAssicurazioneProperty.code = ""; properties.tipoAssicurazioneProperty.value = "";
      properties.durataProperty.value = "";
      properties.tacitoRinnovoProperty.value = "";
      properties.combGaranzieTipologiaProperty.code = ""; properties.combGaranzieTipologiaProperty.value = "";
      properties.combGaranzieDescProperty.value = "";
      properties.premioTipologiaProperty.values = [];
      properties.premioDescProperty.value = "";
      properties.frazPremioProperty.values = [];
      properties.interessiFrazProperty.value = "";
      properties.interessiFrazProperty.frazionamento = {
        mensile: "", mensileSign: "%",
        bimestrale: "", bimestraleSign: "%",
        trimestrale: "", trimestraleSign: "%",
        quadrimestrale: "", quadrimestraleSign: "%",
        semestrale: "", semestraleSign: "%",
      };
      properties.retrDistrProperty.value = "";
      properties.retrDistrProperty.valueSign = "%";
      properties.retrDistrSpecificheProperty.value = "";
      properties.rischiAssicuratiMobilitaProperty.values = [];
      properties.infortuniSuMezziSharingProperty.value = "";
      properties.infortuniInBiciclettaProperty.value = "";
      properties.responsabilitaCivileInBiciclettaProperty.value = "";
      properties.responsabilitaCivileMonopattinoProperty.value = "";
      properties.tutelaLegaleInBiciclettaProperty.value = "";
      properties.furtoBiciclettaProperty.value = "";
      properties.assistenzaBiciclettaTipologiaProperty.values = [];
      properties.assistenzaBiciclettaPeculiaritaProperty.value = "";
      properties.danniCausatiATerziInMobilitaProperty.value = "";
      properties.infortuniSuMezziPubbliciProperty.value = "";
      properties.infortuniInViaggioProperty.value = "";
      properties.rimborsoSpeseMedicheInViaggioProperty.value = "";
      properties.furtoInViaggioProperty.value = "";
      properties.furtoBagaglioProperty.value = "";
      properties.annullamentoViaggioProperty.value = "";
      properties.assistenzaInViaggioTipologiaProperty.values = [];
      properties.assistenzaInViaggioPeculiaritaProperty.value = "";
      properties.altreGaranzieMobilitaProperty.value = "";
      properties.rischiAssicuratiPersonaProperty.values = [];
      properties.morteDaInfortunioProperty.value = "";
      properties.invaliditaPermanenteDaInfortunioProperty.value = "";
      properties.inabilitaTemporaneaDaInfortunioProperty.value = "";
      properties.infortunioConIndennizzoForfettarioProperty.value = "";
      properties.morteDaMalattiaProperty.value = "";
      properties.invaliditaPermanenteDaMalattiaProperty.value = "";
      properties.inabilitaTemporaneaDaMalattiaProperty.value = "";
      properties.graviPatologieMalattieGraviProperty.value = "";
      properties.cureOncologicheProperty.value = "";
      properties.diariaDaRicoveroDaInfortunioMalattiaProperty.value = "";
      properties.diariaDaConvalescenzaProperty.value = "";
      properties.diariaDaImmobilizzazioneProperty.value = "";      
      properties.rimborsoSpeseMedicheGenericheProperty.value = "";
      properties.rimborsoSpeseMedichePerGrandeInterventoChirurgicoProperty.value = "";
      properties.rimborsoSpeseMedichePerRicoveroOInterventoChirurgicoInGenereProperty.value = "";
      properties.visiteSpecialisticheEAccertamentiDiagnosticiProperty.value = "";
      properties.prestazioniAltaSpecializzazioneProperty.value = "";
      properties.trattamentiFisioterapiciRieducativiProperty.value = "";
      properties.interventoChirurgicoConIndennizzoForfettarioProperty.value = "";
      properties.graviRicoveriConIndennizzoForfettarioProperty.value = "";
      properties.statoDiNonAutosufficienzaProperty.value = "";
      properties.statoDiNonAutosufficienzaTemporaneaProperty.value = "";
      properties.cureDentarieProperty.value = "";
      properties.assistenzaAllaPersonaTipologiaProperty.values = [];
      properties.assistenzaAllaPersonaPeculiaritaProperty.value = "";
      properties.esamiDiPrevenzioneCheckUpProperty.value = "";
      properties.danniEsteticiProperty.value = "";
      properties.lentiCorrettiveDaVistaProperty.value = "";
      properties.tutelaLegalePersonaTipologiaProperty.values = [];
      properties.tutelaLegalePersonaPeculiaritaProperty.value = "";
      properties.altreGaranziePersonaProperty.value = "";
      properties.limitiDiEtaProperty.value = "";
      properties.carenzeProperty.value = "";
      properties.rischiAssicuratiCasaEFamigliaProperty.values = [];
      properties.incendioMutuiCasaEFamigliaProperty.value = "";
      properties.incendioFabbricatoCasaEFamigliaProperty.value = "";
      properties.incendioContenutoCasaEFamigliaProperty.value = "";
      properties.incendioAltriRischiCasaEFamigliaTipologiaProperty.values = [];
      properties.incendioAltriRischiCasaEFamigliaPeculiaritaProperty.value = "";
      properties.ricorsoTerziCasaEFamigliaProperty.value = "";
      properties.rischiCatastrofaliTerremotoCasaEFamigliaProperty.value = "";
      properties.rischiCatastrofaliAlluvioneInondazioneCasaEFamigliaProperty.value = "";
      properties.RCProprietaDelFabbricatoCasaEFamigliaProperty.value = "";
      properties.RCConduzioneProperty.value = "";
      properties.RCVitaPrivataProperty.value = "";
      properties.RCRCOCasaEFamigliaProperty.value = "";
      properties.RCAltriRischiCasaEFamigliaProperty.value = "";
      properties.cristalliProperty.value = "";
      properties.furtoERapinaCasaEFamigliaProperty.value = "";
      properties.assistenzaCasaEFamigliaTipologiaProperty.values = [];
      properties.assistenzaCasaEFamigliaPeculiaritaProperty.value = "";
      properties.tutelaLegaleCasaEFamigliaTipologiaProperty.values = [];
      properties.tutelaLegaleCasaEFamigliaPeculiaritaProperty.value = "";
      properties.elettronicaCasaEFamigliaProperty.value = "";
      properties.rischiTecnologiciCasaEFamigliaTipologiaProperty.values = [];
      properties.rischiTecnologiciCasaEFamigliaPeculiaritaProperty.value = "";
      properties.animaliDomesticiCasaEFamigliaTipologiaProperty.values = [];
      properties.animaliDomesticiCasaEFamigliaPeculiaritaProperty.value = "";
      properties.altreGaranzieCasaEFamigliaProperty.value = "";
      properties.rischiAssicuratiAziendaProperty.values = [];
      properties.incendioMutuiAziendaProperty.value = "";
      properties.incendioFabbricatoAziendaProperty.value = "";
      properties.incendioContenutoAziendaProperty.value = "";
      properties.incendioAltriRischiAziendaTipologiaProperty.values = [];
      properties.incendioAltriRischiPeculiaritaAziendaProperty.value = "";
      properties.ricorsoTerziAziendaProperty.value = "";
      properties.rischiCatastrofaliTerremotoAziendaProperty.value = "";
      properties.rischiCatastrofaliAlluvioneInondazioneAziendaProperty.value = "";
      properties.RCProprietaDelFabbricatoAziendaProperty.value = "";
      properties.RCRCTAziendaProperty.value = "";
      properties.RCRCOAziendaProperty.value = "";
      properties.RCAltriRischiAziendaTipologiaProperty.values = [];
      properties.RCAltriRischiPeculiaritaAziendaProperty.value = "";
      properties.furtoERapinaAziendaProperty.value = "";
      properties.assistenzaAziendaTipologiaProperty.values = [];
      properties.assistenzaAziendaPeculiaritaProperty.value = "";
      properties.tutelaLegaleAziendaTipologiaProperty.values = [];
      properties.tutelaLegaleAziendaPeculiaritaProperty.value = "";
      properties.elettronicaAziendaProperty.value = "";
      properties.danniIndirettiAziendaProperty.value = "";
      properties.vetriEInsegneAziendaProperty.value = "";
      properties.rischiTecnologiciAziendaTipologiaProperty.values = [];
      properties.rischiTecnologiciAziendaPeculiaritaProperty.value = "";
      properties.altreGaranzieAziendaProperty.value = "";
      properties.rischiAssicuratiProfessionistiProperty.values = [];
      properties.RCProfAreaTecnicaProperty.value = "";
      properties.RCProfAreaTecnicaAltriRischiTipologiaProperty.values = [];
      properties.RCProfAreaTecnicaAltriRischiPeculiaritaProperty.value = "";
      properties.RCProfAreaEconomicaGiuridicaProperty.value = "";
      properties.RCProfAreaEconomicaGiuridicaAltriRischiTipologiaProperty.values = [];
      properties.RCProfAreaEconomicaGiuridicaAltriRischiPeculiaritaProperty.value = "";
      properties.RCProfAreaMedicaProperty.value = "";
      properties.RCProfAreaMedicaAltriRischiTipologiaProperty.values = [];
      properties.RCProfAreaMedicaAltriRischiPeculiaritaProperty.value = "";
      properties.RCProfAltraAreaProperty.value = "";
      properties.RCRCTProfessionistiProperty.value = "";
      properties.RCRCOProfessionistiProperty.value = "";
      properties.RCProprietaEConduzioneProperty.value = "";
      properties.assistenzaProfessionistiProperty.value = "";
      properties.tutelaLegaleProfessionistiProperty.value = "";
      properties.rischiTecnologiciProfessionistiProperty.value = "";
      properties.infortuniProperty.value = "";
      properties.incendioEDanniAllaProprietaProperty.value = "";
      properties.furtoERapinaProfessionistiProperty.value = "";
      properties.elettronicaProfessionistiProperty.value = "";
      properties.vetriECristalliProfessionistiProperty.value = "";
      properties.altreGaranzieProfessionistiProperty.value = "";
      properties.innovazioneProperty.value = "";
      properties.noteProperty.value = "";

      selectChoices.piuTariffe = { code: "", description: "" };
      selectChoices.compagnia = { code: "", description: "", extCode: "" };
      selectChoices.canale = [];
      selectChoices.modDistribuzione = [];
      selectChoices.mercato = [];
      selectChoices.lineaBusiness = [];
      selectChoices.tipologiaGaranzieMobilita = [];
      selectChoices.tipologiaGaranziePersona = [];
      selectChoices.tipologiaGaranzieCasaEFamiglia = [];
      selectChoices.tipologiaGaranzieAzienda = [];
      selectChoices.tipologiaGaranzieProfessionisti = [];
      selectChoices.prodCommercio = { code: "", description: "" };
      selectChoices.tipoAssicurazione = { code: "", description: "" };
      selectChoices.combGaranzieTipologia = { code: "", description: "" };
      selectChoices.premioTipologia = [];
      selectChoices.frazPremio = [];
      selectChoices.rischiAssicuratiMobilita = [];
      selectChoices.assistenzaBiciclettaMobilitaTipologia = [];
      selectChoices.assistenzaInViaggioMobilitaTipologia = [];
      selectChoices.rischiAssicuratiPersona = [];
      selectChoices.assistenzaAllaPersonaTipologia = [];
      selectChoices.tutelaLegalePersonaTipologia = [];
      selectChoices.rischiAssicuratiCasaEFamiglia = [];
      selectChoices.incendioAltriRischiCasaEFamigliaTipologia = [];
      selectChoices.assistenzaCasaEFamigliaTipologia = [];
      selectChoices.tutelaLegaleCasaEFamigliaTipologia = [];
      selectChoices.rischiTecnologiciCasaEFamigliaTipologia = [];
      selectChoices.animaliDomesticiCasaEFamigliaTipologia = [];
      selectChoices.rischiAssicuratiAzienda = [];
      selectChoices.incendioAltriRischiAziendaTipologia = [];
      selectChoices.RCAltriRischiAziendaTipologia = [];
      selectChoices.assistenzaAziendaTipologia = [];
      selectChoices.tutelaLegaleAziendaTipologia = [];
      selectChoices.rischiTecnologiciAziendaTipologia = [];
      selectChoices.rischiAssicuratiProfessionisti = [];
      selectChoices.RCProfAreaTecnicaAltriRischiTipologia = [];
      selectChoices.RCProfAreaEconomicaGiuridicaAltriRischiTipologia = [];
      selectChoices.RCProfAreaMedicaAltriRischiTipologia = [];
    },
    setPropertiesDefaultCode() {
      if (properties.piuTariffeProperty.code == "") { properties.piuTariffeProperty.code = "1b"; }
      if (properties.compagniaProperty.code == "") { properties.compagniaProperty.code = "2"; }
      if (properties.prodCommercioProperty.code == "") { properties.prodCommercioProperty.code = "16"; }
    },
    prefillCodeValue: function(property: any, propCode: string, propValue: string, choices: any, options: any [], propExtCode: string) {
      property.code = propCode;
      property.value = propValue;
      if (propCode.match(/\./)) {
        const v = options.find((o: any) => o.code === propCode);
        if (propExtCode === undefined) {
          choices = { code: propCode, description: v ? v.description : propValue };
        } else {
          choices = { code: propCode, description: v ? v.description : propValue, extCode: propExtCode };
        }
      } else if (propCode.length > 0) {
        if (propExtCode === undefined) {
          choices = { code: propCode, description: propValue };
        } else {
          choices = { code: propCode, description: propValue, extCode: propExtCode };
        }
      } else {
        if (propExtCode === undefined) {
          choices = { code: '', description: '' };
        } else {
          choices = { code: '', description: '' , extCode: propExtCode };
        }
      }

      return choices;
    },
    prefillValues: function(property: any, values: any [], choices: any, options: any []) {
      property.values = values;
      if (values.length > 0) {
        choices = [];
        for (let i = 0; i < values.length; i++) {
          const v = options.find((o: any) => o.code === values[i].code);
          choices.push({ code: v.code, description: v.description});
        }
      } else {
        choices = [];
      }

      return choices;
    },
    prefillProperties: async function() {
      const vm = this as any;

      // se si arriva da Database.vue bisogna prefillare i campi
      if (vm.productIdSelected != undefined) {
        vm.startLoading();

        const serviceCallReturnValue = await requestService
          .getProduct(vm.productIdSelected)
          .then(handleResponse)
          .then((result: any) => {
            const prodotto = result.properties[0].value;
            const piuTariffeCode = result.properties[1].code;
            const piuTariffeValue = result.properties[1].value;
            const codProdottiCollegati = result.properties[2].value;
            const compagniaCode = result.properties[3].code;
            const compagniaValue = result.properties[3].value;
            const compagniaExtCode = result.properties[3].extCode;
            const canaleValues = result.properties[4].values;
            const distributoriValues = result.properties[5].values;
            const modDistribuzioneValues = result.properties[6].values;
            const mercatoValues = result.properties[7].values;
            const destinatari = result.properties[8].value;
            const targetMarket = result.properties[9].value;
            const descProdotto = result.properties[10].value;
            const lineaBusinessValues = result.properties[11].values;
            const tipologiaGaranzieMobilitaValue = result.properties[12].value;
            const tipologiaGaranzieMobilitaValues = result.properties[12].values;
            const tipologiaGaranziePersonaValue = result.properties[13].value;
            const tipologiaGaranziePersonaValues = result.properties[13].values;
            const tipologiaGaranzieCasaEFamigliaValue = result.properties[14].value;
            const tipologiaGaranzieCasaEFamigliaValues = result.properties[14].values;
            const tipologiaGaranzieAziendaValue = result.properties[15].value;
            const tipologiaGaranzieAziendaValues = result.properties[15].values;
            const tipologiaGaranzieProfessionistiValue = result.properties[16].value;
            const tipologiaGaranzieProfessionistiValues = result.properties[16].values;
            const combGaranzieTipologiaCode = result.properties[17].code;
            const combGaranzieTipologiaValue = result.properties[17].value;
            const combGaranzieDesc = result.properties[18].value;
            const prodCommercioCode = result.properties[19].code;
            const prodCommercioValue = result.properties[19].value;
            const inizioComm = result.properties[20].value;
            const fineComm = result.properties[21].value;
            const edizioneDIPAgg = result.properties[22].value;
            const tipoAssicurazioneCode = result.properties[23].code;
            const tipoAssicurazioneValue = result.properties[23].value;
            const durata = result.properties[24].value;
            const tacitoRinnovo = result.properties[25].value;
            const premioTipologiaValues = result.properties[26].values;
            const premioDesc = result.properties[27].value;
            const frazPremioValue = result.properties[28].value;
            const frazPremioValues = result.properties[28].values;
            const interessiFrazValue = result.properties[29].value;
            const interessiFrazFrazionamento = result.properties[29].frazionamento;
            const retrocessioneDistribValue = result.properties[30].value;
            const retrocessioneDistribValueSign = result.properties[30].valueSign;
            const retrDistrSpecifiche = result.properties[31].value;
            const rischiAssicuratiMobilitaValue = result.properties[32].value;
            const rischiAssicuratiMobilitaValues = result.properties[32].values;
            const infortuniSuMezziSharing = result.properties[33].value;
            const infortuniInBicicletta = result.properties[34].value;
            const responsabilitaCivileInBicicletta = result.properties[35].value;
            const responsabilitaCivileMonopattino = result.properties[36].value;
            const tutelaLegaleInBicicletta = result.properties[37].value;
            const furtoBicicletta = result.properties[38].value;
            const assistenzaBiciclettaTipologiaValue = result.properties[39].value;
            const assistenzaBiciclettaTipologiaValues = result.properties[39].values;
            const assistenzaBiciclettaPeculiarita = result.properties[40].value;
            const danniCausatiATerziInMobilita = result.properties[41].value;
            const infortuniSuMezziPubblici = result.properties[42].value;
            const infortuniInViaggio = result.properties[43].value;
            const rimborsoSpeseMedicheInViaggio = result.properties[44].value;
            const furtoInViaggio = result.properties[45].value;
            const furtoBagaglio = result.properties[46].value;
            const annullamentoViaggio = result.properties[47].value;
            const assistenzaInViaggioTipologiaValue = result.properties[48].value;
            const assistenzaInViaggioTipologiaValues = result.properties[48].values;
            const assistenzaInViaggioPeculiarita = result.properties[49].value;
            const altreGaranzieMobilita = result.properties[50].value;
            const rischiAssicuratiPersonaValue = result.properties[51].value;
            const rischiAssicuratiPersonaValues = result.properties[51].values;
            const morteDaInfortunio = result.properties[52].value;
            const invaliditaPermanenteDaInfortunio = result.properties[53].value;
            const inabilitaTemporaneaDaInfortunio = result.properties[54].value;
            const infortunioConIndennizzoForfettario = result.properties[55].value;
            const morteDaMalattia = result.properties[56].value;
            const invaliditaPermanenteDaMalattia = result.properties[57].value;
            const inabilitaTemporaneaDaMalattia = result.properties[58].value;
            const graviPatologieMalattieGravi = result.properties[59].value;
            const cureOncologiche = result.properties[60].value;
            const diariaDaRicoveroDaInfortunioMalattia = result.properties[61].value;
            const diariaDaConvalescenza = result.properties[62].value;
            const diariaDaImmobilizzazione = result.properties[63].value;
            const rimborsoSpeseMedicheGenericheProperty = result.properties[64].value;
            const rimborsoSpeseMedichePerGrandeInterventoChirurgico = result.properties[65].value;
            const rimborsoSpeseMedichePerRicoveroOInterventoChirurgicoInGenere = result.properties[66].value;
            const visiteSpecialisticheEAccertamentiDiagnostici = result.properties[67].value;
            const prestazioniAltaSpecializzazione = result.properties[68].value;
            const trattamentiFisioterapiciRieducativi = result.properties[69].value;
            const interventoChirurgicoConIndennizzoForfettario = result.properties[70].value;
            const graviRicoveriConIndennizzoForfettario = result.properties[71].value;
            const statoDiNonAutosufficienza = result.properties[72].value;
            const statoDiNonAutosufficienzaTemporanea = result.properties[73].value;
            const cureDentarieProperty = result.properties[74].value;
            const assistenzaAllaPersonaTipologiaValue = result.properties[75].value;
            const assistenzaAllaPersonaTipologiaValues = result.properties[75].values;
            const assistenzaAllaPersonaPeculiarita = result.properties[76].value;
            const esamiDiPrevenzioneCheckUp = result.properties[77].value;
            const danniEstetici = result.properties[78].value;
            const lentiCorrettiveDaVista = result.properties[79].value;
            const tutelaLegalePersonaTipologiaValue = result.properties[80].value;
            const tutelaLegalePersonaTipologiaValues = result.properties[80].values;
            const tutelaLegalePersonaPeculiarita = result.properties[81].value;
            const altreGaranziePersona = result.properties[82].value;
            const limitiDiEta = result.properties[83].value;
            const carenze = result.properties[84].value;
            const rischiAssicuratiCasaEFamigliaValue = result.properties[85].value;
            const rischiAssicuratiCasaEFamigliaValues = result.properties[85].values;
            const incendioMutuiCasaEFamiglia = result.properties[86].value;
            const incendioFabbricatoCasaEFamiglia = result.properties[87].value;
            const incendioContenutoCasaEFamiglia = result.properties[88].value;
            const incendioAltriRischiCasaEFamigliaTipologiaValue = result.properties[89].value;
            const incendioAltriRischiCasaEFamigliaTipologiaValues = result.properties[89].values;
            const incendioAltriRischiCasaEFamigliaPeculiarita = result.properties[90].value;
            const ricorsoTerziCasaEFamiglia = result.properties[91].value;
            const rischiCatastrofaliTerremotoCasaEFamiglia = result.properties[92].value;
            const rischiCatastrofaliAlluvioneInondazioneCasaEFamiglia = result.properties[93].value;
            const RCProprietaDelFabbricatoCasaEFamiglia = result.properties[94].value;
            const RCConduzione = result.properties[95].value;
            const RCVitaPrivata = result.properties[96].value;
            const RCRCOCasaEFamiglia = result.properties[97].value;
            const RCAltriRischiCasaEFamiglia = result.properties[98].value;
            const cristalli = result.properties[99].value;
            const furtoERapinaCasaEFamiglia = result.properties[100].value;
            const assistenzaCasaEFamigliaTipologiaValue = result.properties[101].value;
            const assistenzaCasaEFamigliaTipologiaValues = result.properties[101].values;
            const assistenzaCasaEFamigliaPeculiarita = result.properties[102].value;
            const tutelaLegaleCasaEFamigliaTipologiaValue = result.properties[103].value;
            const tutelaLegaleCasaEFamigliaTipologiaValues = result.properties[103].values;
            const tutelaLegaleCasaEFamigliaPeculiarita = result.properties[104].value;
            const elettronicaCasaEFamiglia = result.properties[105].value;
            const rischiTecnologiciCasaEFamigliaTipologiaValue = result.properties[106].value;
            const rischiTecnologiciCasaEFamigliaTipologiaValues = result.properties[106].values;
            const rischiTecnologiciCasaEFamigliaPeculiarita = result.properties[107].value;
            const animaliDomesticiCasaEFamigliaTipologiaValue = result.properties[108].value;
            const animaliDomesticiCasaEFamigliaTipologiaValues = result.properties[108].values;
            const animaliDomesticiCasaEFamigliaPeculiarita = result.properties[109].value;
            const altreGaranzieCasaEFamiglia = result.properties[110].value;
            const rischiAssicuratiAziendaValue = result.properties[111].value;
            const rischiAssicuratiAziendaValues = result.properties[111].values;
            const incendioMutuiAzienda = result.properties[112].value;
            const incendioFabbricatoAzienda = result.properties[113].value;
            const incendioContenutoAzienda = result.properties[114].value;
            const incendioAltriRischiAziendaTipologiaValue = result.properties[115].value;
            const incendioAltriRischiAziendaTipologiaValues = result.properties[115].values;
            const incendioAltriRischiPeculiaritaAzienda = result.properties[116].value;
            const ricorsoTerziAzienda = result.properties[117].value;
            const rischiCatastrofaliTerremotoAzienda = result.properties[118].value;
            const rischiCatastrofaliAlluvioneInondazioneAzienda = result.properties[119].value;
            const RCProprietaDelFabbricatoAzienda = result.properties[120].value;
            const RCRCTAzienda = result.properties[121].value;
            const RCRCOAzienda = result.properties[122].value;
            const RCAltriRischiAziendaTipologiaValue = result.properties[123].value;
            const RCAltriRischiAziendaTipologiaValues = result.properties[123].values;
            const RCAltriRischiPeculiaritaAzienda = result.properties[124].value;
            const furtoERapinaAzienda = result.properties[125].value;
            const assistenzaAziendaTipologiaValue = result.properties[126].value;
            const assistenzaAziendaTipologiaValues = result.properties[126].values;
            const assistenzaAziendaPeculiarita = result.properties[127].value;
            const tutelaLegaleAziendaTipologiaValue = result.properties[128].value;
            const tutelaLegaleAziendaTipologiaValues = result.properties[128].values;
            const tutelaLegaleAziendaPeculiarita = result.properties[129].value;
            const elettronicaAzienda = result.properties[130].value;
            const danniIndirettiAzienda = result.properties[131].value;
            const vetriEInsegneAzienda = result.properties[132].value;
            const rischiTecnologiciAziendaTipologiaValue = result.properties[133].value;
            const rischiTecnologiciAziendaTipologiaValues = result.properties[133].values;
            const rischiTecnologiciAziendaPeculiarita = result.properties[134].value;
            const altreGaranzieAzienda = result.properties[135].value;
            const rischiAssicuratiProfessionistiValue = result.properties[136].value;
            const rischiAssicuratiProfessionistiValues = result.properties[136].values;
            const RCProfAreaTecnica = result.properties[137].value;
            const RCProfAreaTecnicaAltriRischiTipologiaValue = result.properties[138].value;
            const RCProfAreaTecnicaAltriRischiTipologiaValues = result.properties[138].values;
            const RCProfAreaTecnicaAltriRischiPeculiarita = result.properties[139].value;
            const RCProfAreaEconomicaGiuridica = result.properties[140].value;
            const RCProfAreaEconomicaGiuridicaAltriRischiTipologiaValue = result.properties[141].value;
            const RCProfAreaEconomicaGiuridicaAltriRischiTipologiaValues = result.properties[141].values;
            const RCProfAreaEconomicaGiuridicaAltriRischiPeculiarita = result.properties[142].value;
            const RCProfAreaMedica = result.properties[143].value;
            const RCProfAreaMedicaAltriRischiTipologiaValue = result.properties[144].value;
            const RCProfAreaMedicaAltriRischiTipologiaValues = result.properties[144].values;
            const RCProfAreaMedicaAltriRischiPeculiarita = result.properties[145].value;
            const RCProfAltraArea = result.properties[146].value;
            const RCRCTProfessionisti = result.properties[147].value;
            const RCRCOProfessionisti = result.properties[148].value;
            const RCProprietaEConduzione = result.properties[149].value;
            const assistenzaProfessionisti = result.properties[150].value;
            const tutelaLegaleProfessionisti = result.properties[151].value;
            const rischiTecnologiciProfessionisti = result.properties[152].value;
            const infortuni = result.properties[153].value;
            const incendioEDanniAllaProprieta = result.properties[154].value;
            const furtoERapinaProfessionisti = result.properties[155].value;
            const elettronicaProfessionisti = result.properties[156].value;
            const vetriECristalliProfessionisti = result.properties[157].value;
            const altreGaranzieProfessionisti = result.properties[158].value;
            const innovazione = result.properties[159].value;
            const note = result.properties[160].value;
            const codProdotto = result.properties[161].value;

            //...

            // prodotto
            properties.prodottoProperty.value = prodotto;
            // prodotto
            properties.codProdottoProperty.value = codProdotto;
            // piuTariffe
            selectChoices.piuTariffe = vm.prefillCodeValue(properties.piuTariffeProperty, piuTariffeCode, piuTariffeValue, selectChoices.piuTariffe, vm.piuTariffeOptions);            
            // prodotti collegati
            properties.codProdCollegatoProperty.value = codProdottiCollegati;
            // compagnia
            selectChoices.compagnia = vm.prefillCodeValue(properties.compagniaProperty, compagniaCode, compagniaValue, selectChoices.compagnia, vm.compagniaOptions, compagniaExtCode);
            // canale
            selectChoices.canale = vm.prefillValues(properties.canaleProperty,canaleValues,selectChoices.canale,vm.canaleOptions);
            // distributori
            selectChoices.distributori = vm.prefillValues(properties.distributoriProperty,distributoriValues,selectChoices.distributori,vm.distributoriOptions);
            // modalità di distribuzione
            selectChoices.modDistribuzione = vm.prefillValues(properties.modDistribuzioneProperty,modDistribuzioneValues,selectChoices.modDistribuzione,vm.modDistribuzioneOptions);
            // mercato
            selectChoices.mercato = vm.prefillValues(properties.mercatoProperty,mercatoValues,selectChoices.mercato,vm.mercatoOptions);
            // destinatari
            properties.destinatariProperty.value = destinatari;
            // target market
            properties.targetMarketProperty.value = targetMarket;
            // desc prodotto
            properties.descProdottoProperty.value = descProdotto;
            // linea di business
            selectChoices.lineaBusiness = vm.prefillValues(properties.lineaBusinessProperty,lineaBusinessValues,selectChoices.lineaBusiness,vm.lineaBusinessOptions);
            // tipologia garanzie mobilità
            properties.tipologiaGaranzieMobilitaProperty.value = tipologiaGaranzieMobilitaValue;
            selectChoices.tipologiaGaranzieMobilita = vm.prefillValues(properties.tipologiaGaranzieMobilitaProperty,tipologiaGaranzieMobilitaValues,selectChoices.tipologiaGaranzieMobilita,vm.tipologiaGaranzieMobilitaOptions);
            // tipologia garanzie persona
            properties.tipologiaGaranziePersonaProperty.value = tipologiaGaranziePersonaValue;
            selectChoices.tipologiaGaranziePersona = vm.prefillValues(properties.tipologiaGaranziePersonaProperty,tipologiaGaranziePersonaValues,selectChoices.tipologiaGaranziePersona,vm.tipologiaGaranziePersonaOptions);
            // tipologia garanzie casa e famiglia
            properties.tipologiaGaranzieCasaEFamigliaProperty.value = tipologiaGaranzieCasaEFamigliaValue;
            selectChoices.tipologiaGaranzieCasaEFamiglia = vm.prefillValues(properties.tipologiaGaranzieCasaEFamigliaProperty,tipologiaGaranzieCasaEFamigliaValues,selectChoices.tipologiaGaranzieCasaEFamiglia,vm.tipologiaGaranzieCasaEFamigliaOptions);
            // tipologia garanzie azienda
            properties.tipologiaGaranzieAziendaProperty.value = tipologiaGaranzieAziendaValue;
            selectChoices.tipologiaGaranzieAzienda = vm.prefillValues(properties.tipologiaGaranzieAziendaProperty,tipologiaGaranzieAziendaValues,selectChoices.tipologiaGaranzieAzienda,vm.tipologiaGaranzieAziendaOptions);
            vm.altroTipologiaGaranzieAzienda = vm.getAltroDescription(properties.tipologiaGaranzieAziendaProperty,"14.7",vm.tipologiaGaranzieAziendaOptions);
            // tipologia garanzie professionisti
            properties.tipologiaGaranzieProfessionistiProperty.value = tipologiaGaranzieProfessionistiValue;
            selectChoices.tipologiaGaranzieProfessionisti = vm.prefillValues(properties.tipologiaGaranzieProfessionistiProperty,tipologiaGaranzieProfessionistiValues,selectChoices.tipologiaGaranzieProfessionisti,vm.tipologiaGaranzieProfessionistiOptions);
            // prodotto in commercio
            selectChoices.prodCommercio = vm.prefillCodeValue(properties.prodCommercioProperty, prodCommercioCode, prodCommercioValue, selectChoices.prodCommercio, vm.prodCommercioOptions);
            // inizio commercializzazione
            properties.inizioCommProperty.value = inizioComm;
            properties.inizioCommProperty.dateValue = vm.dateFromString(inizioComm);
            // fine commercializzazione
            properties.fineCommProperty.value = fineComm;
            properties.fineCommProperty.dateValue = vm.dateFromString(fineComm);
            // edizione DIP aggiuntivo
            properties.edizioneDIPAggProperty.value = edizioneDIPAgg;
            properties.edizioneDIPAggProperty.dateValue = vm.dateFromString(edizioneDIPAgg);
            // tipologia di assicurazione
            selectChoices.tipoAssicurazione = vm.prefillCodeValue(properties.tipoAssicurazioneProperty, tipoAssicurazioneCode, tipoAssicurazioneValue, selectChoices.tipoAssicurazione, vm.tipoAssicurazioneOptions);
            // durata contrattuale
            properties.durataProperty.value = durata;
            // tacito rinnovo
            properties.tacitoRinnovoProperty.value = tacitoRinnovo;
            // combinazione garanzie tipologia
            selectChoices.combGaranzieTipologia = vm.prefillCodeValue(properties.combGaranzieTipologiaProperty, combGaranzieTipologiaCode, combGaranzieTipologiaValue, selectChoices.combGaranzieTipologia, vm.combGaranzieTipologiaOptions);
            // combinazione garanzie descrizione
            properties.combGaranzieDescProperty.value = combGaranzieDesc;
            // premio - tipologia
            selectChoices.premioTipologia = vm.prefillValues(properties.premioTipologiaProperty,premioTipologiaValues,selectChoices.premioTipologia,vm.premioTipologiaOptions);
            // premio - descrizione
            properties.premioDescProperty.value = premioDesc;
            // frazionamento del premio
            properties.frazPremioProperty.value = frazPremioValue;
            selectChoices.frazPremio = vm.prefillValues(properties.frazPremioProperty,frazPremioValues,selectChoices.frazPremio,vm.frazPremioOptions);
            // interessi di frazionamento
            properties.interessiFrazProperty.value = interessiFrazValue;
            properties.interessiFrazProperty.frazionamento = interessiFrazFrazionamento;
            // retrocessione alla distribuzione
            properties.retrDistrProperty.value = retrocessioneDistribValue;
            properties.retrDistrProperty.valueSign = retrocessioneDistribValueSign;
            // retrocessione alla distribuzione - specifiche
            properties.retrDistrSpecificheProperty.value = retrDistrSpecifiche;
            // rischi assicurati mobilità
            properties.rischiAssicuratiMobilitaProperty.value = rischiAssicuratiMobilitaValue;
            selectChoices.rischiAssicuratiMobilita = vm.prefillValues(properties.rischiAssicuratiMobilitaProperty,rischiAssicuratiMobilitaValues,selectChoices.rischiAssicuratiMobilita,vm.rischiAssicuratiMobilitaOptions);
            // infortuni su mezzi sharing
            properties.infortuniSuMezziSharingProperty.value = infortuniSuMezziSharing;
            // infortuni in bicicletta
            properties.infortuniInBiciclettaProperty.value = infortuniInBicicletta;
            // responsabilità civile in bicicletta
            properties.responsabilitaCivileInBiciclettaProperty.value = responsabilitaCivileInBicicletta;
            // Responsabilità civile per danni da utilizzo di monopattino elettrico
            properties.responsabilitaCivileMonopattinoProperty.value = responsabilitaCivileMonopattino;
            // tutela legale in bicicletta
            properties.tutelaLegaleInBiciclettaProperty.value = tutelaLegaleInBicicletta;
            // furto bicicletta
            properties.furtoBiciclettaProperty.value = furtoBicicletta;
            // assistenza bicicletta - tipologia
            properties.assistenzaBiciclettaTipologiaProperty.value = assistenzaBiciclettaTipologiaValue;
            selectChoices.assistenzaBiciclettaMobilitaTipologia = vm.prefillValues(properties.assistenzaBiciclettaTipologiaProperty,assistenzaBiciclettaTipologiaValues,selectChoices.assistenzaBiciclettaMobilitaTipologia,vm.assistenzaBiciclettaMobilitaTipologiaOptions);
            vm.altroAssistenzaBiciclettaTipologia = vm.getAltroDescription(properties.assistenzaBiciclettaTipologiaProperty,"33.12",vm.assistenzaBiciclettaMobilitaTipologiaOptions);
            // assistenza bicicletta - peculiarità
            properties.assistenzaBiciclettaPeculiaritaProperty.value = assistenzaBiciclettaPeculiarita;
            // danni causati a terzi in mobilità
            properties.danniCausatiATerziInMobilitaProperty.value = danniCausatiATerziInMobilita;
            // infortuni su mezzi pubblici
            properties.infortuniSuMezziPubbliciProperty.value = infortuniSuMezziPubblici;
            // infortuni in viaggio
            properties.infortuniInViaggioProperty.value = infortuniInViaggio;
            // rimborso spese mediche in viaggio
            properties.rimborsoSpeseMedicheInViaggioProperty.value = rimborsoSpeseMedicheInViaggio;
            // furto in viaggio
            properties.furtoInViaggioProperty.value = furtoInViaggio;
            // furto bagaglio
            properties.furtoBagaglioProperty.value = furtoBagaglio;
            // annullamento viaggio
            properties.annullamentoViaggioProperty.value = annullamentoViaggio;
            // assistenza in viaggio - tipologia
            properties.assistenzaInViaggioTipologiaProperty.value = assistenzaInViaggioTipologiaValue;
            selectChoices.assistenzaInViaggioMobilitaTipologia = vm.prefillValues(properties.assistenzaInViaggioTipologiaProperty,assistenzaInViaggioTipologiaValues,selectChoices.assistenzaInViaggioMobilitaTipologia,vm.assistenzaInViaggioMobilitaTipologiaOptions);
            vm.altroAssistenzaInViaggioTipologia = vm.getAltroDescription(properties.assistenzaInViaggioTipologiaProperty,"41.18",vm.assistenzaInViaggioMobilitaTipologiaOptions);
            // assistenza in viaggio - peculiarità
            properties.assistenzaInViaggioPeculiaritaProperty.value = assistenzaInViaggioPeculiarita;
            // altre garanzie mobilità
            properties.altreGaranzieMobilitaProperty.value = altreGaranzieMobilita;
            // rischi assicurati persona
            properties.rischiAssicuratiPersonaProperty.value = rischiAssicuratiPersonaValue;
            selectChoices.rischiAssicuratiPersona = vm.prefillValues(properties.rischiAssicuratiPersonaProperty,rischiAssicuratiPersonaValues,selectChoices.rischiAssicuratiPersona,vm.rischiAssicuratiPersonaOptions);
            // morte da infortunio
            properties.morteDaInfortunioProperty.value = morteDaInfortunio;
            // invalidità permanente da infortunio
            properties.invaliditaPermanenteDaInfortunioProperty.value = invaliditaPermanenteDaInfortunio;
            // inabilità temporanea da infortunio
            properties.inabilitaTemporaneaDaInfortunioProperty.value = inabilitaTemporaneaDaInfortunio;
            // infortunio con indennizzo forfettario
            properties.infortunioConIndennizzoForfettarioProperty.value = infortunioConIndennizzoForfettario;
            // morte da malattia
            properties.morteDaMalattiaProperty.value = morteDaMalattia;
            // invalidità permanente da malattia
            properties.invaliditaPermanenteDaMalattiaProperty.value = invaliditaPermanenteDaMalattia;
            // inabilità temporanea da malattia
            properties.inabilitaTemporaneaDaMalattiaProperty.value = inabilitaTemporaneaDaMalattia;
            // gravi patologie (malattie gravi)
            properties.graviPatologieMalattieGraviProperty.value = graviPatologieMalattieGravi;
            // cure oncologiche
            properties.cureOncologicheProperty.value = cureOncologiche;
            // diaria da ricovero da infortunio/malattia
            properties.diariaDaRicoveroDaInfortunioMalattiaProperty.value = diariaDaRicoveroDaInfortunioMalattia;
            // diaria da convalescenza
            properties.diariaDaConvalescenzaProperty.value = diariaDaConvalescenza;
            // diaria da immobilizzazione
            properties.diariaDaImmobilizzazioneProperty.value = diariaDaImmobilizzazione;            
            // rimborso spese mediche generiche
            properties.rimborsoSpeseMedicheGenericheProperty.value = rimborsoSpeseMedicheGenericheProperty;
            // rimborso spese mediche per grande intervento chirurgico
            properties.rimborsoSpeseMedichePerGrandeInterventoChirurgicoProperty.value = rimborsoSpeseMedichePerGrandeInterventoChirurgico;
            // rimborso spese mediche per ricovero o intervento chirurgico in genere
            properties.rimborsoSpeseMedichePerRicoveroOInterventoChirurgicoInGenereProperty.value = rimborsoSpeseMedichePerRicoveroOInterventoChirurgicoInGenere;
            // visite specialistiche e accertamenti diagnostici
            properties.visiteSpecialisticheEAccertamentiDiagnosticiProperty.value = visiteSpecialisticheEAccertamentiDiagnostici;
            // prestazioni di alta specializzazione
            properties.prestazioniAltaSpecializzazioneProperty.value = prestazioniAltaSpecializzazione;
            // trattamenti fisioterapici rieducativi
            properties.trattamentiFisioterapiciRieducativiProperty.value = trattamentiFisioterapiciRieducativi;
            // intervento chirurgico con indennizzo forfettario
            properties.interventoChirurgicoConIndennizzoForfettarioProperty.value = interventoChirurgicoConIndennizzoForfettario;
            // gravi ricoveri con indennizzo forfettario
            properties.graviRicoveriConIndennizzoForfettarioProperty.value = graviRicoveriConIndennizzoForfettario;
            // stato di non autosufficienza
            properties.statoDiNonAutosufficienzaProperty.value = statoDiNonAutosufficienza;
            // stato di non autosufficienza temporanea
            properties.statoDiNonAutosufficienzaTemporaneaProperty.value = statoDiNonAutosufficienzaTemporanea;
            // cure dentarie
            properties.cureDentarieProperty.value = cureDentarieProperty;
            // assistenza alla persona - tipologia
            properties.assistenzaAllaPersonaTipologiaProperty.value = assistenzaAllaPersonaTipologiaValue;
            selectChoices.assistenzaAllaPersonaTipologia = vm.prefillValues(properties.assistenzaAllaPersonaTipologiaProperty,assistenzaAllaPersonaTipologiaValues,selectChoices.assistenzaAllaPersonaTipologia,vm.assistenzaAllaPersonaTipologiaOptions);
            vm.altroAssistenzaAllaPersonaTipologia = vm.getAltroDescription(properties.assistenzaAllaPersonaTipologiaProperty,"63.28",vm.assistenzaAllaPersonaTipologiaOptions);
            // assistenza alla persona - peculiarità
            properties.assistenzaAllaPersonaPeculiaritaProperty.value = assistenzaAllaPersonaPeculiarita;
            // esami di prevenzione (check-up)
            properties.esamiDiPrevenzioneCheckUpProperty.value = esamiDiPrevenzioneCheckUp;
            // danni estetici
            properties.danniEsteticiProperty.value = danniEstetici;
            // lenti correttive da vista
            properties.lentiCorrettiveDaVistaProperty.value = lentiCorrettiveDaVista;
            // tutela legale persona - tipologia
            properties.tutelaLegalePersonaTipologiaProperty.value = tutelaLegalePersonaTipologiaValue;
            selectChoices.tutelaLegalePersonaTipologia = vm.prefillValues(properties.tutelaLegalePersonaTipologiaProperty,tutelaLegalePersonaTipologiaValues,selectChoices.tutelaLegalePersonaTipologia,vm.tutelaLegalePersonaTipologiaOptions);
            vm.altroTutelaLegalePersonaTipologia = vm.getAltroDescription(properties.tutelaLegalePersonaTipologiaProperty,"68.6",vm.tutelaLegalePersonaTipologiaOptions);
            // tutela legale persona - peculiarità
            properties.tutelaLegalePersonaPeculiaritaProperty.value = tutelaLegalePersonaPeculiarita;
            // altre garanzie persona
            properties.altreGaranziePersonaProperty.value = altreGaranziePersona;
            // limiti di età
            properties.limitiDiEtaProperty.value = limitiDiEta;
            // carenze
            properties.carenzeProperty.value = carenze;
            // rischi assicurati casa e famiglia
            properties.rischiAssicuratiCasaEFamigliaProperty.value = rischiAssicuratiCasaEFamigliaValue;
            selectChoices.rischiAssicuratiCasaEFamiglia = vm.prefillValues(properties.rischiAssicuratiCasaEFamigliaProperty,rischiAssicuratiCasaEFamigliaValues,selectChoices.rischiAssicuratiCasaEFamiglia,vm.rischiAssicuratiCasaEFamigliaOptions);
            // incendio - mutui
            properties.incendioMutuiCasaEFamigliaProperty.value = incendioMutuiCasaEFamiglia;
            // incendio - fabbricato
            properties.incendioFabbricatoCasaEFamigliaProperty.value = incendioFabbricatoCasaEFamiglia;
            // incendio - contenuto
            properties.incendioContenutoCasaEFamigliaProperty.value = incendioContenutoCasaEFamiglia;
            // incendio - altri rischi - tipologia
            properties.incendioAltriRischiCasaEFamigliaTipologiaProperty.value = incendioAltriRischiCasaEFamigliaTipologiaValue;
            selectChoices.incendioAltriRischiCasaEFamigliaTipologia = vm.prefillValues(properties.incendioAltriRischiCasaEFamigliaTipologiaProperty,incendioAltriRischiCasaEFamigliaTipologiaValues,selectChoices.incendioAltriRischiCasaEFamigliaTipologia,vm.incendioAltriRischiCasaEFamigliaTipologiaOptions);
            vm.altroIncendioAltriRischiCasaEFamigliaTipologia = vm.getAltroDescription(properties.incendioAltriRischiCasaEFamigliaTipologiaProperty,"77.10",vm.incendioAltriRischiCasaEFamigliaTipologiaOptions);
            // incendio - altri rischi - peculiarità
            properties.incendioAltriRischiCasaEFamigliaPeculiaritaProperty.value = incendioAltriRischiCasaEFamigliaPeculiarita;
            // ricorso terzi
            properties.ricorsoTerziCasaEFamigliaProperty.value = ricorsoTerziCasaEFamiglia;
            // rischi catastrofali - terremoto
            properties.rischiCatastrofaliTerremotoCasaEFamigliaProperty.value = rischiCatastrofaliTerremotoCasaEFamiglia;
            // rischi catastrofali - alluvione/inondazione
            properties.rischiCatastrofaliAlluvioneInondazioneCasaEFamigliaProperty.value = rischiCatastrofaliAlluvioneInondazioneCasaEFamiglia;
            // RC - proprietà del fabbricato
            properties.RCProprietaDelFabbricatoCasaEFamigliaProperty.value = RCProprietaDelFabbricatoCasaEFamiglia;
            // RC - conduzione
            properties.RCConduzioneProperty.value = RCConduzione;
            // RC - vita privata
            properties.RCVitaPrivataProperty.value = RCVitaPrivata;
            // RC - RCO
            properties.RCRCOCasaEFamigliaProperty.value = RCRCOCasaEFamiglia;
            // RC - altri rischi
            properties.RCAltriRischiCasaEFamigliaProperty.value = RCAltriRischiCasaEFamiglia;
            // cristalli
            properties.cristalliProperty.value = cristalli;
            // furto e rapina
            properties.furtoERapinaCasaEFamigliaProperty.value = furtoERapinaCasaEFamiglia;
            // assistenza casa e famiglia - tipologia
            properties.assistenzaCasaEFamigliaTipologiaProperty.value = assistenzaCasaEFamigliaTipologiaValue;
            selectChoices.assistenzaCasaEFamigliaTipologia = vm.prefillValues(properties.assistenzaCasaEFamigliaTipologiaProperty,assistenzaCasaEFamigliaTipologiaValues,selectChoices.assistenzaCasaEFamigliaTipologia,vm.assistenzaCasaEFamigliaTipologiaOptions);
            vm.altroAssistenzaCasaEFamigliaTipologia = vm.getAltroDescription(properties.assistenzaCasaEFamigliaTipologiaProperty,"89.30",vm.assistenzaCasaEFamigliaTipologiaOptions);
            // assistenza casa e famiglia - peculiarità
            properties.assistenzaCasaEFamigliaPeculiaritaProperty.value = assistenzaCasaEFamigliaPeculiarita;
            // tutela legale casa e famiglia - tipologia
            properties.tutelaLegaleCasaEFamigliaTipologiaProperty.value = tutelaLegaleCasaEFamigliaTipologiaValue;
            selectChoices.tutelaLegaleCasaEFamigliaTipologia = vm.prefillValues(properties.tutelaLegaleCasaEFamigliaTipologiaProperty,tutelaLegaleCasaEFamigliaTipologiaValues,selectChoices.tutelaLegaleCasaEFamigliaTipologia,vm.tutelaLegaleCasaEFamigliaTipologiaOptions);
            vm.altroTutelaLegaleCasaEFamigliaTipologia = vm.getAltroDescription(properties.tutelaLegaleCasaEFamigliaTipologiaProperty,"91.19",vm.tutelaLegaleCasaEFamigliaTipologiaOptions);
            // tutela legale casa e famiglia - peculiarità
            properties.tutelaLegaleCasaEFamigliaPeculiaritaProperty.value = tutelaLegaleCasaEFamigliaPeculiarita;
            // elettronica
            properties.elettronicaCasaEFamigliaProperty.value = elettronicaCasaEFamiglia;
            // cyber risk/rischi tecnologici casa e famiglia - tipologia
            properties.rischiTecnologiciCasaEFamigliaTipologiaProperty.value = rischiTecnologiciCasaEFamigliaTipologiaValue;
            selectChoices.rischiTecnologiciCasaEFamigliaTipologia = vm.prefillValues(properties.rischiTecnologiciCasaEFamigliaTipologiaProperty,rischiTecnologiciCasaEFamigliaTipologiaValues,selectChoices.rischiTecnologiciCasaEFamigliaTipologia,vm.rischiTecnologiciCasaEFamigliaTipologiaOptions);
            vm.altroRischiTecnologiciCasaEFamigliaTipologia = vm.getAltroDescription(properties.rischiTecnologiciCasaEFamigliaTipologiaProperty,"94.8",vm.rischiTecnologiciCasaEFamigliaTipologiaOptions);
            // cyber risk/rischi tecnologici casa e famiglia - peculiarità
            properties.rischiTecnologiciCasaEFamigliaPeculiaritaProperty.value = rischiTecnologiciCasaEFamigliaPeculiarita;
            // animali domestici - tipologia
            properties.animaliDomesticiCasaEFamigliaTipologiaProperty.value = animaliDomesticiCasaEFamigliaTipologiaValue;
            selectChoices.animaliDomesticiCasaEFamigliaTipologia = vm.prefillValues(properties.animaliDomesticiCasaEFamigliaTipologiaProperty,animaliDomesticiCasaEFamigliaTipologiaValues,selectChoices.animaliDomesticiCasaEFamigliaTipologia,vm.animaliDomesticiCasaEFamigliaTipologiaOptions);
            vm.altroAnimaliDomesticiCasaEFamigliaTipologia = vm.getAltroDescription(properties.animaliDomesticiCasaEFamigliaTipologiaProperty,"96.16",vm.animaliDomesticiCasaEFamigliaTipologiaOptions);
            // animali domestici - peculiarità
            properties.animaliDomesticiCasaEFamigliaPeculiaritaProperty.value = animaliDomesticiCasaEFamigliaPeculiarita;
            // altre garanzie casa e famiglia
            properties.altreGaranzieCasaEFamigliaProperty.value = altreGaranzieCasaEFamiglia;
            // rischi assicurati azienda
            properties.rischiAssicuratiAziendaProperty.value = rischiAssicuratiAziendaValue;
            selectChoices.rischiAssicuratiAzienda = vm.prefillValues(properties.rischiAssicuratiAziendaProperty,rischiAssicuratiAziendaValues,selectChoices.rischiAssicuratiAzienda,vm.rischiAssicuratiAziendaOptions);
            // incendio - mutui
            properties.incendioMutuiAziendaProperty.value = incendioMutuiAzienda;
            // incendio - fabbricato
            properties.incendioFabbricatoAziendaProperty.value = incendioFabbricatoAzienda;
            // incendio - contenuto
            properties.incendioContenutoAziendaProperty.value = incendioContenutoAzienda;
            // incendio - altri rischi - tipologia
            properties.incendioAltriRischiAziendaTipologiaProperty.value = incendioAltriRischiAziendaTipologiaValue;
            selectChoices.incendioAltriRischiAziendaTipologia = vm.prefillValues(properties.incendioAltriRischiAziendaTipologiaProperty,incendioAltriRischiAziendaTipologiaValues,selectChoices.incendioAltriRischiAziendaTipologia,vm.incendioAltriRischiAziendaTipologiaOptions);
            vm.altroIncendioAltriRischiAziendaTipologia = vm.getAltroDescription(properties.incendioAltriRischiAziendaTipologiaProperty,"103.11",vm.incendioAltriRischiAziendaTipologiaOptions);
            // incendio - altri rischi - peculiarità
            properties.incendioAltriRischiPeculiaritaAziendaProperty.value = incendioAltriRischiPeculiaritaAzienda;
            // ricorso terzi
            properties.ricorsoTerziAziendaProperty.value = ricorsoTerziAzienda;
            // rischi catastrofali - terremoto
            properties.rischiCatastrofaliTerremotoAziendaProperty.value = rischiCatastrofaliTerremotoAzienda;
            // rischi catastrofali - alluvione/inondazione
            properties.rischiCatastrofaliAlluvioneInondazioneAziendaProperty.value = rischiCatastrofaliAlluvioneInondazioneAzienda;
            // RC - proprietà del fabbricato
            properties.RCProprietaDelFabbricatoAziendaProperty.value = RCProprietaDelFabbricatoAzienda;
            // RC - RCT
            properties.RCRCTAziendaProperty.value = RCRCTAzienda;
            // RC - RCO
            properties.RCRCOAziendaProperty.value = RCRCOAzienda;
            // RC - altri rischi - tipologia
            properties.RCAltriRischiAziendaTipologiaProperty.value = RCAltriRischiAziendaTipologiaValue;
            selectChoices.RCAltriRischiAziendaTipologia = vm.prefillValues(properties.RCAltriRischiAziendaTipologiaProperty,RCAltriRischiAziendaTipologiaValues,selectChoices.RCAltriRischiAziendaTipologia,vm.RCAltriRischiAziendaTipologiaOptions);
            vm.altroRCAltriRischiAziendaTipologia = vm.getAltroDescription(properties.RCAltriRischiAziendaTipologiaProperty,"111.12",vm.RCAltriRischiAziendaTipologiaOptions);
            // RC - altri rischi - peculiarità
            properties.RCAltriRischiPeculiaritaAziendaProperty.value = RCAltriRischiPeculiaritaAzienda;
            // furto e rapina
            properties.furtoERapinaAziendaProperty.value = furtoERapinaAzienda;
            // assistenza azienda - tipologia
            properties.assistenzaAziendaTipologiaProperty.value = assistenzaAziendaTipologiaValue;
            selectChoices.assistenzaAziendaTipologia = vm.prefillValues(properties.assistenzaAziendaTipologiaProperty,assistenzaAziendaTipologiaValues,selectChoices.assistenzaAziendaTipologia,vm.assistenzaAziendaTipologiaOptions);
            vm.altroAssistenzaAziendaTipologia = vm.getAltroDescription(properties.assistenzaAziendaTipologiaProperty,"114.11",vm.assistenzaAziendaTipologiaOptions);
            // assistenza azienda - peculiarità
            properties.assistenzaAziendaPeculiaritaProperty.value = assistenzaAziendaPeculiarita;
            // tutela legale azienda - tipologia
            properties.tutelaLegaleAziendaTipologiaProperty.value = tutelaLegaleAziendaTipologiaValue;
            selectChoices.tutelaLegaleAziendaTipologia = vm.prefillValues(properties.tutelaLegaleAziendaTipologiaProperty,tutelaLegaleAziendaTipologiaValues,selectChoices.tutelaLegaleAziendaTipologia,vm.tutelaLegaleAziendaTipologiaOptions);
            vm.altroTutelaLegaleAziendaTipologia = vm.getAltroDescription(properties.tutelaLegaleAziendaTipologiaProperty,"116.11",vm.tutelaLegaleAziendaTipologiaOptions);
            // tutela legale azienda - Peculiarità
            properties.tutelaLegaleAziendaPeculiaritaProperty.value = tutelaLegaleAziendaPeculiarita;
            // elettronica
            properties.elettronicaAziendaProperty.value = elettronicaAzienda;
            // danni indiretti
            properties.danniIndirettiAziendaProperty.value = danniIndirettiAzienda;
            // vetri e insegne
            properties.vetriEInsegneAziendaProperty.value = vetriEInsegneAzienda;
            // cyber risk/rischi tecnologici azienda - tipologia
            properties.rischiTecnologiciAziendaTipologiaProperty.value = rischiTecnologiciAziendaTipologiaValue;
            selectChoices.rischiTecnologiciAziendaTipologia = vm.prefillValues(properties.rischiTecnologiciAziendaTipologiaProperty,rischiTecnologiciAziendaTipologiaValues,selectChoices.rischiTecnologiciAziendaTipologia,vm.rischiTecnologiciAziendaTipologiaOptions);
            vm.altroRischiTecnologiciAziendaTipologia = vm.getAltroDescription(properties.rischiTecnologiciAziendaTipologiaProperty,"121.13",vm.rischiTecnologiciAziendaTipologiaOptions);
            // cyber risk/rischi tecnologici azienda - peculiarità
            properties.rischiTecnologiciAziendaPeculiaritaProperty.value =  rischiTecnologiciAziendaPeculiarita;
            // altre garanzie azienda
            properties.altreGaranzieAziendaProperty.value =  altreGaranzieAzienda;
            // rischi assicurati professionisti
            properties.rischiAssicuratiProfessionistiProperty.value = rischiAssicuratiProfessionistiValue;
            selectChoices.rischiAssicuratiProfessionisti = vm.prefillValues(properties.rischiAssicuratiProfessionistiProperty,rischiAssicuratiProfessionistiValues,selectChoices.rischiAssicuratiProfessionisti,vm.rischiAssicuratiProfessionistiOptions);
            // RC professionale (area tecnica)
            properties.RCProfAreaTecnicaProperty.value = RCProfAreaTecnica;
            // RC professionale (area tecnica) - altri rischi - tipologia
            properties.RCProfAreaTecnicaAltriRischiTipologiaProperty.value = RCProfAreaTecnicaAltriRischiTipologiaValue;
            selectChoices.RCProfAreaTecnicaAltriRischiTipologia = vm.prefillValues(properties.RCProfAreaTecnicaAltriRischiTipologiaProperty,RCProfAreaTecnicaAltriRischiTipologiaValues,selectChoices.RCProfAreaTecnicaAltriRischiTipologia,vm.RCProfAreaTecnicaAltriRischiTipologiaOptions);
            vm.altroRCProfAreaTecnicaAltriRischiTipologia = vm.getAltroDescription(properties.RCProfAreaTecnicaAltriRischiTipologiaProperty,"126.9",vm.RCProfAreaTecnicaAltriRischiTipologiaOptions);
            // RC professionale (area tecnica) - altri rischi - peculiarità
            properties.RCProfAreaTecnicaAltriRischiPeculiaritaProperty.value = RCProfAreaTecnicaAltriRischiPeculiarita;
            // RC professionale (area economica-giuridica)
            properties.RCProfAreaEconomicaGiuridicaProperty.value = RCProfAreaEconomicaGiuridica;
            // RC professionale (area economica-giuridica) - altri rischi - tipologia
            properties.RCProfAreaEconomicaGiuridicaAltriRischiTipologiaProperty.value = RCProfAreaEconomicaGiuridicaAltriRischiTipologiaValue;
            selectChoices.RCProfAreaEconomicaGiuridicaAltriRischiTipologia = vm.prefillValues(properties.RCProfAreaEconomicaGiuridicaAltriRischiTipologiaProperty,RCProfAreaEconomicaGiuridicaAltriRischiTipologiaValues,selectChoices.RCProfAreaEconomicaGiuridicaAltriRischiTipologia,vm.RCProfAreaEconomicaGiuridicaAltriRischiTipologiaOptions);
            vm.altroRCProfAreaEconomicaGiuridicaAltriRischiTipologia = vm.getAltroDescription(properties.RCProfAreaEconomicaGiuridicaAltriRischiTipologiaProperty,"129.6",vm.RCProfAreaEconomicaGiuridicaAltriRischiTipologiaOptions);
            // RC professionale (area economica-giuridica) - altri rischi - peculiarità
            properties.RCProfAreaEconomicaGiuridicaAltriRischiPeculiaritaProperty.value = RCProfAreaEconomicaGiuridicaAltriRischiPeculiarita;
            // RC professionale (area medica)
            properties.RCProfAreaMedicaProperty.value = RCProfAreaMedica;
            // RC professionale (area medica) - altri rischi - tipologia
            properties.RCProfAreaMedicaAltriRischiTipologiaProperty.value = RCProfAreaMedicaAltriRischiTipologiaValue;
            selectChoices.RCProfAreaMedicaAltriRischiTipologia = vm.prefillValues(properties.RCProfAreaMedicaAltriRischiTipologiaProperty,RCProfAreaMedicaAltriRischiTipologiaValues,selectChoices.RCProfAreaMedicaAltriRischiTipologia,vm.RCProfAreaMedicaAltriRischiTipologiaOptions);
            vm.altroRCProfAreaMedicaAltriRischiTipologia = vm.getAltroDescription(properties.RCProfAreaMedicaAltriRischiTipologiaProperty,"132.5",vm.RCProfAreaMedicaAltriRischiTipologiaOptions);
            // RC professionale (area medica) - altri Rischi - peculiarità
            properties.RCProfAreaMedicaAltriRischiPeculiaritaProperty.value = RCProfAreaMedicaAltriRischiPeculiarita;
            // RC professionale (altra area)
            properties.RCProfAltraAreaProperty.value = RCProfAltraArea;
            // RC - RCT
            properties.RCRCTProfessionistiProperty.value = RCRCTProfessionisti;
            // RC - RCO
            properties.RCRCOProfessionistiProperty.value = RCRCOProfessionisti;
            // RC - proprietà e conduzione
            properties.RCProprietaEConduzioneProperty.value = RCProprietaEConduzione;
            // assistenza professionisti
            properties.assistenzaProfessionistiProperty.value = assistenzaProfessionisti;
            // tutela legale professionisti
            properties.tutelaLegaleProfessionistiProperty.value = tutelaLegaleProfessionisti;
            // cyber risk/Rischi tecnologici professionisti
            properties.rischiTecnologiciProfessionistiProperty.value = rischiTecnologiciProfessionisti;
            // infortuni
            properties.infortuniProperty.value = infortuni;
            // incendio e danni alla proprietà
            properties.incendioEDanniAllaProprietaProperty.value = incendioEDanniAllaProprieta;
            // furto e rapina
            properties.furtoERapinaProfessionistiProperty.value = furtoERapinaProfessionisti;
            // elettronica
            properties.elettronicaProfessionistiProperty.value = elettronicaProfessionisti;
            // vetri e cristalli
            properties.vetriECristalliProfessionistiProperty.value = vetriECristalliProfessionisti;
            // altre garanzie professionisti
            properties.altreGaranzieProfessionistiProperty.value = altreGaranzieProfessionisti;
            // innovazione
            properties.innovazioneProperty.value = innovazione;
            // note
            properties.noteProperty.value = note;
          })
          .catch(() => {
            vm.openModalError();
          })

        vm.stopLoading();
      } else {
        vm.changePiuTariffe();
        vm.changeFineComm();
        vm.changePremioTipologia();
        vm.changeFrazPremio();
        vm.changeTipologiaGaranzie();
      }
    },
    setDatePropertiesValue() {
      const vm = this as any;

      properties.inizioCommProperty.value = vm.formatDate(properties.inizioCommProperty.dateValue);
      if (properties.prodCommercioProperty.code == "16.2" || properties.prodCommercioProperty.code == "") {
        properties.fineCommProperty.value = vm.formatDate(properties.fineCommProperty.dateValue);
      }
      properties.edizioneDIPAggProperty.value = vm.formatDate(properties.edizioneDIPAggProperty.dateValue);
    },
    setAltroDescription: function(property: any, options: any, altroCode: string, altroSpecificValue: string) {
      const vm = this as any;

      let cleanValue = "";
      for (let i = 0; i < options.length; i++) {
        if (options[i].code == altroCode) {
          cleanValue = options[i].description;
        }
      }
      for (let i = 0; i < property.values.length; i++) {
        if (property.values[i].code == altroCode) {
          property.values[i].description = cleanValue + ": " + altroSpecificValue;
        }
      }
    },
    getAltroDescription: function(property: any, optionCode: string, options: any) {
      let optionDescription = "";
      for (let i = 0; i < options.length; i++) {
        if (options[i].code == optionCode) {
          optionDescription = options[i].description + " ";
        }
      }
      for (let i = 0; i < property.values.length; i++) {
        const propIValue = property.values[i] as any;
        if (propIValue.code == optionCode) {
          return propIValue.description.substring((optionDescription + " ").length);
        }
      }
      return undefined;
    },
    preparePropList() {
      const vm = this as any;

      vm.setAltroDescription(properties.tipologiaGaranzieAziendaProperty,vm.tipologiaGaranzieAziendaOptions,"14.7",vm.altroTipologiaGaranzieAzienda);
      vm.setAltroDescription(properties.assistenzaBiciclettaTipologiaProperty,vm.assistenzaBiciclettaMobilitaTipologiaOptions,"33.12",vm.altroAssistenzaBiciclettaTipologia);
      vm.setAltroDescription(properties.assistenzaInViaggioTipologiaProperty,vm.assistenzaInViaggioMobilitaTipologiaOptions,"41.18",vm.altroAssistenzaInViaggioTipologia);
      vm.setAltroDescription(properties.assistenzaAllaPersonaTipologiaProperty,vm.assistenzaAllaPersonaTipologiaOptions,"63.28",vm.altroAssistenzaAllaPersonaTipologia);
      vm.setAltroDescription(properties.tutelaLegalePersonaTipologiaProperty,vm.tutelaLegalePersonaTipologiaOptions,"68.6",vm.altroTutelaLegalePersonaTipologia);
      vm.setAltroDescription(properties.incendioAltriRischiCasaEFamigliaTipologiaProperty,vm.incendioAltriRischiCasaEFamigliaTipologiaOptions,"77.10",vm.altroIncendioAltriRischiCasaEFamigliaTipologia);
      vm.setAltroDescription(properties.assistenzaCasaEFamigliaTipologiaProperty,vm.assistenzaCasaEFamigliaTipologiaOptions,"89.30",vm.altroAssistenzaCasaEFamigliaTipologia);
      vm.setAltroDescription(properties.tutelaLegaleCasaEFamigliaTipologiaProperty,vm.tutelaLegaleCasaEFamigliaTipologiaOptions,"91.19",vm.altroTutelaLegaleCasaEFamigliaTipologia);
      vm.setAltroDescription(properties.rischiTecnologiciCasaEFamigliaTipologiaProperty,vm.rischiTecnologiciCasaEFamigliaTipologiaOptions,"94.8",vm.altroRischiTecnologiciCasaEFamigliaTipologia);
      vm.setAltroDescription(properties.animaliDomesticiCasaEFamigliaTipologiaProperty,vm.animaliDomesticiCasaEFamigliaTipologiaOptions,"96.16",vm.altroAnimaliDomesticiCasaEFamigliaTipologia);
      vm.setAltroDescription(properties.incendioAltriRischiAziendaTipologiaProperty,vm.incendioAltriRischiAziendaTipologiaOptions,"103.11",vm.altroIncendioAltriRischiAziendaTipologia);
      vm.setAltroDescription(properties.RCAltriRischiAziendaTipologiaProperty,vm.RCAltriRischiAziendaTipologiaOptions,"111.12",vm.altroRCAltriRischiAziendaTipologia);
      vm.setAltroDescription(properties.assistenzaAziendaTipologiaProperty,vm.assistenzaAziendaTipologiaOptions,"114.11",vm.altroAssistenzaAziendaTipologia);
      vm.setAltroDescription(properties.tutelaLegaleAziendaTipologiaProperty,vm.tutelaLegaleAziendaTipologiaOptions,"116.11",vm.altroTutelaLegaleAziendaTipologia);
      vm.setAltroDescription(properties.rischiTecnologiciAziendaTipologiaProperty,vm.rischiTecnologiciAziendaTipologiaOptions,"121.13",vm.altroRischiTecnologiciAziendaTipologia);
      vm.setAltroDescription(properties.RCProfAreaTecnicaAltriRischiTipologiaProperty,vm.RCProfAreaTecnicaAltriRischiTipologiaOptions,"126.9",vm.altroRCProfAreaTecnicaAltriRischiTipologia);
      vm.setAltroDescription(properties.RCProfAreaEconomicaGiuridicaAltriRischiTipologiaProperty,vm.RCProfAreaEconomicaGiuridicaAltriRischiTipologiaOptions,"129.6",vm.altroRCProfAreaEconomicaGiuridicaAltriRischiTipologia);
      vm.setAltroDescription(properties.RCProfAreaMedicaAltriRischiTipologiaProperty,vm.RCProfAreaMedicaAltriRischiTipologiaOptions,"132.5",vm.altroRCProfAreaMedicaAltriRischiTipologia);

      vm.setDatePropertiesValue();

      vm.propList = [
        properties.prodottoProperty,
        properties.piuTariffeProperty,
        properties.codProdCollegatoProperty,
        properties.compagniaProperty,
        properties.canaleProperty,
        properties.distributoriProperty,
        properties.modDistribuzioneProperty,
        properties.mercatoProperty,
        properties.destinatariProperty,
        properties.targetMarketProperty,
        properties.descProdottoProperty,
        properties.lineaBusinessProperty,
        properties.tipologiaGaranzieMobilitaProperty,
        properties.tipologiaGaranziePersonaProperty,
        properties.tipologiaGaranzieCasaEFamigliaProperty,
        properties.tipologiaGaranzieAziendaProperty,
        properties.tipologiaGaranzieProfessionistiProperty,
        properties.combGaranzieTipologiaProperty,
        properties.combGaranzieDescProperty,
        properties.prodCommercioProperty,
        properties.inizioCommProperty,
        properties.fineCommProperty,
        properties.edizioneDIPAggProperty,
        properties.tipoAssicurazioneProperty,
        properties.durataProperty,
        properties.tacitoRinnovoProperty,
        properties.premioTipologiaProperty,
        properties.premioDescProperty,
        properties.frazPremioProperty,
        properties.interessiFrazProperty,
        properties.retrDistrProperty,
        properties.retrDistrSpecificheProperty,
        properties.rischiAssicuratiMobilitaProperty,
        properties.infortuniSuMezziSharingProperty,
        properties.infortuniInBiciclettaProperty,
        properties.responsabilitaCivileInBiciclettaProperty,
        properties.responsabilitaCivileMonopattinoProperty,
        properties.tutelaLegaleInBiciclettaProperty,
        properties.furtoBiciclettaProperty,
        properties.assistenzaBiciclettaTipologiaProperty,
        properties.assistenzaBiciclettaPeculiaritaProperty,
        properties.danniCausatiATerziInMobilitaProperty,
        properties.infortuniSuMezziPubbliciProperty,
        properties.infortuniInViaggioProperty,
        properties.rimborsoSpeseMedicheInViaggioProperty,
        properties.furtoInViaggioProperty,
        properties.furtoBagaglioProperty,
        properties.annullamentoViaggioProperty,
        properties.assistenzaInViaggioTipologiaProperty,
        properties.assistenzaInViaggioPeculiaritaProperty,
        properties.altreGaranzieMobilitaProperty,
        properties.rischiAssicuratiPersonaProperty,
        properties.morteDaInfortunioProperty,
        properties.invaliditaPermanenteDaInfortunioProperty,
        properties.inabilitaTemporaneaDaInfortunioProperty,
        properties.infortunioConIndennizzoForfettarioProperty,
        properties.morteDaMalattiaProperty,
        properties.invaliditaPermanenteDaMalattiaProperty,
        properties.inabilitaTemporaneaDaMalattiaProperty,
        properties.graviPatologieMalattieGraviProperty,
        properties.cureOncologicheProperty,
        properties.diariaDaRicoveroDaInfortunioMalattiaProperty,
        properties.diariaDaConvalescenzaProperty,
        properties.diariaDaImmobilizzazioneProperty,
        properties.rimborsoSpeseMedicheGenericheProperty,
        properties.rimborsoSpeseMedichePerGrandeInterventoChirurgicoProperty,
        properties.rimborsoSpeseMedichePerRicoveroOInterventoChirurgicoInGenereProperty,
        properties.visiteSpecialisticheEAccertamentiDiagnosticiProperty,
        properties.prestazioniAltaSpecializzazioneProperty,
        properties.trattamentiFisioterapiciRieducativiProperty,
        properties.interventoChirurgicoConIndennizzoForfettarioProperty,
        properties.graviRicoveriConIndennizzoForfettarioProperty,
        properties.statoDiNonAutosufficienzaProperty,
        properties.statoDiNonAutosufficienzaTemporaneaProperty,
        properties.cureDentarieProperty,
        properties.assistenzaAllaPersonaTipologiaProperty,
        properties.assistenzaAllaPersonaPeculiaritaProperty,
        properties.esamiDiPrevenzioneCheckUpProperty,
        properties.danniEsteticiProperty,
        properties.lentiCorrettiveDaVistaProperty,
        properties.tutelaLegalePersonaTipologiaProperty,
        properties.tutelaLegalePersonaPeculiaritaProperty,
        properties.altreGaranziePersonaProperty,
        properties.limitiDiEtaProperty,
        properties.carenzeProperty,
        properties.rischiAssicuratiCasaEFamigliaProperty,
        properties.incendioMutuiCasaEFamigliaProperty,
        properties.incendioFabbricatoCasaEFamigliaProperty,
        properties.incendioContenutoCasaEFamigliaProperty,
        properties.incendioAltriRischiCasaEFamigliaTipologiaProperty,
        properties.incendioAltriRischiCasaEFamigliaPeculiaritaProperty,
        properties.ricorsoTerziCasaEFamigliaProperty,
        properties.rischiCatastrofaliTerremotoCasaEFamigliaProperty,
        properties.rischiCatastrofaliAlluvioneInondazioneCasaEFamigliaProperty,
        properties.RCProprietaDelFabbricatoCasaEFamigliaProperty,
        properties.RCConduzioneProperty,
        properties.RCVitaPrivataProperty,
        properties.RCRCOCasaEFamigliaProperty,
        properties.RCAltriRischiCasaEFamigliaProperty,
        properties.cristalliProperty,
        properties.furtoERapinaCasaEFamigliaProperty,
        properties.assistenzaCasaEFamigliaTipologiaProperty,
        properties.assistenzaCasaEFamigliaPeculiaritaProperty,
        properties.tutelaLegaleCasaEFamigliaTipologiaProperty,
        properties.tutelaLegaleCasaEFamigliaPeculiaritaProperty,
        properties.elettronicaCasaEFamigliaProperty,
        properties.rischiTecnologiciCasaEFamigliaTipologiaProperty,
        properties.rischiTecnologiciCasaEFamigliaPeculiaritaProperty,
        properties.animaliDomesticiCasaEFamigliaTipologiaProperty,
        properties.animaliDomesticiCasaEFamigliaPeculiaritaProperty,
        properties.altreGaranzieCasaEFamigliaProperty,
        properties.rischiAssicuratiAziendaProperty,
        properties.incendioMutuiAziendaProperty,
        properties.incendioFabbricatoAziendaProperty,
        properties.incendioContenutoAziendaProperty,
        properties.incendioAltriRischiAziendaTipologiaProperty,
        properties.incendioAltriRischiPeculiaritaAziendaProperty,
        properties.ricorsoTerziAziendaProperty,
        properties.rischiCatastrofaliTerremotoAziendaProperty,
        properties.rischiCatastrofaliAlluvioneInondazioneAziendaProperty,
        properties.RCProprietaDelFabbricatoAziendaProperty,
        properties.RCRCTAziendaProperty,
        properties.RCRCOAziendaProperty,
        properties.RCAltriRischiAziendaTipologiaProperty,
        properties.RCAltriRischiPeculiaritaAziendaProperty,
        properties.furtoERapinaAziendaProperty,
        properties.assistenzaAziendaTipologiaProperty,
        properties.assistenzaAziendaPeculiaritaProperty,
        properties.tutelaLegaleAziendaTipologiaProperty,
        properties.tutelaLegaleAziendaPeculiaritaProperty,
        properties.elettronicaAziendaProperty,
        properties.danniIndirettiAziendaProperty,
        properties.vetriEInsegneAziendaProperty,
        properties.rischiTecnologiciAziendaTipologiaProperty,
        properties.rischiTecnologiciAziendaPeculiaritaProperty,
        properties.altreGaranzieAziendaProperty,
        properties.rischiAssicuratiProfessionistiProperty,
        properties.RCProfAreaTecnicaProperty,
        properties.RCProfAreaTecnicaAltriRischiTipologiaProperty,
        properties.RCProfAreaTecnicaAltriRischiPeculiaritaProperty,
        properties.RCProfAreaEconomicaGiuridicaProperty,
        properties.RCProfAreaEconomicaGiuridicaAltriRischiTipologiaProperty,
        properties.RCProfAreaEconomicaGiuridicaAltriRischiPeculiaritaProperty,
        properties.RCProfAreaMedicaProperty,
        properties.RCProfAreaMedicaAltriRischiTipologiaProperty,
        properties.RCProfAreaMedicaAltriRischiPeculiaritaProperty,
        properties.RCProfAltraAreaProperty,
        properties.RCRCTProfessionistiProperty,
        properties.RCRCOProfessionistiProperty,
        properties.RCProprietaEConduzioneProperty,
        properties.assistenzaProfessionistiProperty,
        properties.tutelaLegaleProfessionistiProperty,
        properties.rischiTecnologiciProfessionistiProperty,
        properties.infortuniProperty,
        properties.incendioEDanniAllaProprietaProperty,
        properties.furtoERapinaProfessionistiProperty,
        properties.elettronicaProfessionistiProperty,
        properties.vetriECristalliProfessionistiProperty,
        properties.altreGaranzieProfessionistiProperty,
        properties.innovazioneProperty,
        properties.noteProperty,
        properties.codProdottoProperty,
      ];
    },
    printStringListItem(item: any) {
      return (item.valueLabel !== undefined && item.valueLabel !== null && item.valueLabel !== "" ? item.valueLabel + " " : "") + item.value + item.valueSign
    },
    selectedFile: function(fileList: any[]) {
      if (!fileList.length) return;
      this.massiveFile = fileList[0];
    },
    uploadMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.uploadMassive(categories.DANNI_NON_AUTO, vm.massiveFile)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          if (result !== undefined) {
            vm.massiveLoaded = true;
            vm.massiveResult = result;
          } else {
            vm.closeModalMassivo();
            vm.openModalError("Non è stato possibile caricare il file.");
          }
        })
        .catch(() => {
          vm.stopLoading();
          vm.openModalError("Non è stato possibile caricare il file.");
        });
    },
    confirmMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.confirmMassive(vm.massiveResult.massiveId)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.closeModalMassivo();
          vm.openModalError("Prodotti caricati.", "OK"); // non è un errore, sfrutto per aprire la modale
        })
        .catch(() => {
          vm.stopLoading();
          vm.openModalError("Non è stato possibile confermare i dati caricati.");
        });
    },
    deleteMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.deleteMassive(vm.massiveResult.massiveId)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.closeModalMassivo();
          vm.openModalError("Caricamento massivo annullato.", "OK"); // non è un errore, sfrutto per aprire la modale
        })
        .catch(() => {
          vm.stopLoading();
          vm.closeModalMassivo();
        });
    },
    printVersatileValues(property: any) {
      const vm = this as any;

      let isPrintStringList = false;
      if (property.type == propertyTypes.STRING_LIST) {
        isPrintStringList = true;
      } else if (property.stringList !== undefined && property.stringList !== null) {
        if (property.stringList.length > 0) {
          isPrintStringList = true;
        }
      }

      let printableValue = "";
      let tooltipValue = "";
      if (property.type == propertyTypes.VALUES) {
        if (property.values.length > 0) {
          //property.values.sort(this._compare);
          if (property.values.length == 1) {
            const item = property.values[0];
            printableValue = item.description;
          } else {
            const maxLi = 3;
            let liCounter = 0;
            let li = "";
            // printableValue & tooltipValue
            const tooltipLi = property.values.map(function(item: any) {
              //li is a subset of what in tooltipLi (all)
              liCounter++;
              if (liCounter < maxLi) {
                li += "<li>" + item.description + "</li>";
              } else if (liCounter == maxLi) {
                li += "<li>" + '...' + "</li>";
              }
              return "<li>" + item.description + "</li>";
            }).join("");

            printableValue = "<div><ul class='dashed'>" + li + "</ul><div>";
            if (liCounter >= maxLi) {
              tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul><div>";
            }
          }
        } else {
          printableValue = property.value;
        }
      } else if (isPrintStringList) {
        if (property.value !== "") {
          printableValue = property.value;
        } else if (property.stringList.length == 1) {
          const item = property.stringList[0];
          printableValue = vm.printStringListItem(item);
        } else {
          const maxLi = 3;
          let liCounter = 0;
          let li = "";
          // printableValue & tooltipValue
          const tooltipLi = property.stringList.map(function(item: any) {
            //li is a subset of what in tooltipLi (all)
            liCounter++;
            if (liCounter < maxLi) {
              li += "<li>" + item.value + item.valueSign + "</li>";
            } else if (liCounter == maxLi) {
              li += "<li>" + '...' + "</li>";
            }
            return "<li>" + item.value + item.valueSign + "</li>";
          }).join("");

          printableValue = "<div><ul class='dashed'>" + li + "</ul><div>";
          if (liCounter >= maxLi) {
            tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul><div>";
          }
        }
      } else if (property.type == propertyTypes.FRAZIONAMENTO) {
        if (property.value === vm.ND) {
          printableValue = property.value;
        } else {
          let values = [];
          if (property.frazionamento.mensile !== vm.ND) {
            values.push("Mensile: " + property.frazionamento.mensile + property.frazionamento.mensileSign);
          }
          if (property.frazionamento.bimestrale !== vm.ND) {
            values.push("Bimestrale: " + property.frazionamento.bimestrale + property.frazionamento.bimestraleSign);
          }
          if (property.frazionamento.trimestrale !== vm.ND) {
            values.push("Trimestrale: " + property.frazionamento.trimestrale + property.frazionamento.trimestraleSign);
          }
          if (property.frazionamento.quadrimestrale !== vm.ND) {
            values.push("Quadrimestrale: " + property.frazionamento.quadrimestrale + property.frazionamento.quadrimestraleSign);
          }
          if (property.frazionamento.semestrale !== vm.ND) {
            values.push("Semestrale: " + property.frazionamento.semestrale + property.frazionamento.semestraleSign);
          }
          if (values.length == 1) {
            printableValue = values[0];
          } else if (values.length > 1) {
            const maxLi = 3;
            let liCounter = 0;
            let li = "";
            const tooltipLi = values.map(function(s: any) {
              liCounter++;
              if (liCounter < maxLi) {
                li += "<li>" + s + "</li>";
              } else if (liCounter == maxLi) {
                li += "<li>" + '...' + "</li>";
              }
              return "<li>" + s + "</li>";
            }).join("");
            printableValue = "<ul class='dashed'>" + li + "</ul>"
            if (liCounter >= maxLi) {
              tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul><div>";
            }
          }
        }
      } else if (property.type == propertyTypes.DATE) {
        const d = vm.dateFromString(property.value);
        if (d != null) {
          printableValue = vm.formatDateF(d, "MM/yyyy");
        } else {
          printableValue = property.value;
        }
      } else {
        const maxCharsPerRow = 40;
        const maxRows = 1;
        let printedRows = 0;
        let flagDots = false;
        if (property.value !== undefined && property.value !== null) {
          if (property.value.length > maxCharsPerRow) {

            for (let i = 0; i < property.value.length && printedRows < maxRows;) {
              let endIndex = Math.min(i+maxCharsPerRow, property.value.length);
              let dots = "";
              if (printedRows+1 == maxRows) {
                dots = "...";
                flagDots = true;
              }
              printableValue += "<div>" + property.value.substring(i, endIndex) + dots + "</div>";
              i += maxCharsPerRow;
              printedRows += 1;
            }

            if (flagDots) {
              tooltipValue = property.value;
            }
          } else {
            printableValue = property.value;
          }
        }
      }

      if (tooltipValue !== undefined && !vm.isEmptyOrSpaces(tooltipValue)) {
        printableValue = tooltipValue;
      }

      printableValue = printableValue.replace(/\n/g, "<br />");

      return printableValue;
    },
    //
    inserisciProdotto: async function() {
      const vm = this as any;
      vm.startLoading();
      let productId = undefined;

      if (vm.productIdSelected === undefined) {
        let nuovoProdotto = {} as any;
        nuovoProdotto = await vm.registraProdotto();
        if (nuovoProdotto == undefined) {
          vm.stopLoading();
          vm.openModalError();
        } else {
          productId = nuovoProdotto.productId;
        }
      } else {
        productId = vm.productIdSelected;
      }

      if (productId === undefined) {
        vm.stopLoading();
        vm.openModalError();
      } else {
        //FINE FUNZIONI DI MAPPING
        vm.valorizzaTendine();

        vm.setDatePropertiesValue();

        vm.setPropertiesDefaultCode();

        vm.preparePropList();

        const serviceCallReturnValue = await requestService
          .addProductPropertyList({
            productId: productId,
            propertyList: vm.propList
          })
          .then(handleResponse)
          .then((result: any) => {
            if (!isNil(result.productId)) {
              vm.esitoRegistrazione = "Registrazione avvenuta con successo";
            } else {
              vm.esitoRegistrazione = "Registrazione KO";
            }

            return result.productId;
          })
          .catch(() => {
            vm.openModalError();
          });

        vm.stopLoading();

        vm.closeModalConfirm();

        vm.openModalConfirmOutcome();
      }
    },
    registraProdotto: async function() {
      const cc = this.customCategory || 'protezione-patrimonio';
      return requestService.initProductWithCustomCategory(categories.DANNI_NON_AUTO, cc).then(handleResponse);
    },
    setPropertyValueBlankIfND: function(property: any) {
      const vm = this as any;

      if (property.value == vm.ND) {
        property.value = "";
      }
    },
    setPropertyCondizionata: function(property: any, conditionKey: any, conditionValue: any) {
      const vm = this as any;

      if (!vm.multivaluesContain(conditionKey, conditionValue)) {
        property.values = [];
        property.value = vm.ND;
      } else {
        vm.setPropertyValueBlankIfND(property);
      }
    },
    isAdmin: function() {
      const vm = this as any;
      const isAdmin = vm.loggedUser.roles.indexOf('admin') >= 0;
      const isAdminView = vm.loggedUser.roles.indexOf('admin-view') >= 0;
      return isAdmin || isAdminView;
    },
    massivo: function() {
      const vm = this as any;
      const isAdmin = vm.loggedUser.roles.indexOf('admin') >= 0;
      const isMassivo = vm.loggedUser.roles.indexOf('massivo') >= 0;

      return isAdmin || isMassivo;
    },
  },
  created() {
    const vm = this as any;

    vm.cleanAllProperties();

    vm.prefillProperties();
  },
  mounted() {
    const vm = this as any;
    if (!vm.loggedUser) {
      vm.home();
    } else {
      const hasRole = vm.loggedUser.roles.indexOf('danni-non-auto') >= 0;

      if (!vm.isAdmin() && !hasRole) {
        vm.home();
      }
    }
  },
  destroyed() {
    const vm = this as any;
    //vm.stopLoading();
    vm.closeModalError();
  },
});
